export default {
  translations: {
    'Try it out': 'جرّبها',
    'Preview not available': 'المعاينة غير متوفرة',
    'New Board': 'لوحة جديدة',
    'Import from .zip': 'استيراد من .zip',
    'Importing...': 'جارٍ الاستيراد...',
    'Failed to import board.': 'فشل استيراد اللوحة.',
    'Create board on the tablet?': 'إنشاء لوحة على الجهاز اللوحي؟',
    'Import board to the tablet?': 'استيراد اللوحة إلى الجهاز اللوحي؟',
    "This board will be created in this user's tablet backup, not in your Portal boards. It will be sent to the tablet on the next sync.":
      'سيتم إنشاء هذه اللوحة في النسخة الاحتياطية للجهاز اللوحي لهذا المستخدم، وليس في لوحاتك على البوابة. سيتم إرسالها إلى الجهاز اللوحي عند المزامنة التالية.',
    'Board title': 'عنوان اللوحة',
    'Enter a title for the board': 'أدخل عنوانًا للوحة',
    'Card language': 'لغة البطاقة',
    'Creating...': 'جارٍ الإنشاء...',
    'Failed to create board.': 'تعذّر إنشاء اللوحة.',
    'Choose an image from the bank, generate one with AI or upload your own.':
      'اختر صورة من البنك، أو أنشئ واحدة بالذكاء الاصطناعي، أو ارفع صورتك.',
    'Used for the symbol bank and speech (text-to-speech) of this board.':
      'يُستخدم لبنك الرموز والنطق (تحويل النص إلى كلام) لهذه اللوحة.',
    'How do you want to start?': 'كيف تريد أن تبدأ؟',
    'Blank board': 'لوحة فارغة',
    'Start with tutorial': 'ابدأ بالبرنامج التعليمي',
    'Create a board from scratch': 'أنشئ لوحة من البداية',
    'Learn the studio with a ready-made board':
      'تعلّم الاستوديو من خلال لوحة جاهزة',
    'Is this your first time creating boards?':
      'هل هذه المرة الأولى التي تنشئ فيها لوحات؟',
    "Don't show this again": 'لا تظهر هذا مجددًا',
    'Choose a title for your board': 'اختر عنوانًا للوحة',
    'Preview board': 'معاينة اللوحة',
    'Displayed text': 'النص المعروض',
    'Back and edit': 'العودة إلى التعديل',
    SMALL: 'صغير',
    MEDIUM: 'متوسط',
    LARGE: 'كبير',
    login: {
      welcome: 'مرحبًا بك في Livox!',
      error:
        'لا يمكن تسجيل الدخول بالبيانات المقدمة. البريد الإلكتروني و/أو كلمة المرور غير صحيحة.',
    },
    payment: {
      purchaseFor: 'الشراء لـ',
      supportEmail: 'البريد الإلكتروني للاتصال',
    },
    paymentRegister: {
      title: 'سجل لشراء Livox',
      orLoginWithAccount: 'هل لديك حساب بالفعل؟',
      loginToComplete: 'سجّل الدخول لإتمام عملية الشراء',
      orRegisterNew: 'أو سجّل لإنشاء حساب جديد',
      email: 'البريد الإلكتروني',
      fullName: 'الاسم الكامل',
      emailRequired: 'البريد الإلكتروني مطلوب',
      fullNameRequired: 'الاسم الكامل مطلوب',
      enterFullName: 'أدخل اسمك الكامل',
      codeInfo:
        'ستتلقى رمزًا مكونًا من 6 أرقام عبر البريد الإلكتروني. الرمز صالح لمدة 15 دقيقة.',
      sending: 'جاري الإرسال...',
      sendCode: 'إرسال رمز التفعيل',
      codeSentTo: 'تم إرسال الرمز إلى',
      activationCode: 'رمز التفعيل',
      resendCode: 'إعادة إرسال الرمز',
      continue: 'متابعة',
      validating: 'جاري التحقق...',
      codeValid: 'الرمز صالح.',
      changeEmail: 'تغيير البريد الإلكتروني',
      password: 'كلمة المرور',
      confirmPassword: 'تأكيد كلمة المرور',
      enterPassword: 'أدخل كلمة المرور',
      confirmYourPassword: 'أكد كلمة المرور',
      passwordRequired: 'كلمة المرور مطلوبة',
      confirmPasswordRequired: 'يرجى تأكيد كلمة المرور',
      activating: 'جاري التفعيل...',
      activateAccount: 'تفعيل الحساب',
      back: 'رجوع',
      accountExists: 'الحساب موجود بالفعل. سجل الدخول للمتابعة.',
      codeSentSuccess:
        'تم إرسال رمز تفعيل مكون من 6 أرقام إلى بريدك الإلكتروني. صالح لمدة 15 دقيقة.',
      newCodeSent: 'تم إرسال رمز جديد إلى بريدك الإلكتروني',
      somethingWrong: 'حدث خطأ ما',
      resendFailed: 'فشل إعادة الإرسال',
      passwordsDontMatch: 'كلمات المرور غير متطابقة',
      activationFailed: 'فشل التفعيل',
      accountActivated: 'تم تفعيل الحساب بنجاح!',
      codeExpired: 'رمز التفعيل منتهي الصلاحية أو غير صالح. اطلب رمزًا جديدًا.',
      invalidCode: 'رمز التفعيل غير صالح.',
      accountAlreadyActive: 'الحساب نشط بالفعل. سجل الدخول.',
      rateLimit: 'انتظر لحظة قبل طلب رمز جديد.',
      passwordRequirements:
        'يجب أن تحتوي كلمة المرور على حرف كبير وحرف صغير ورمز خاص ورقم واحد على الأقل وطول 8 أحرف على الأقل',
      holderAlreadyRegistered:
        'يوجد بالفعل صاحب مسجل بهذا البريد الإلكتروني. يرجى تسجيل الدخول إلى البوابة.',
      holderAlreadyRegisteredTitle: 'الصاحب مسجل بالفعل',
      holderAlreadyRegisteredMessage:
        'يوجد بالفعل صاحب مسجل بهذا البريد الإلكتروني. يرجى تسجيل الدخول إلى البوابة للوصول إلى حسابك.',
      holderAlreadyRegisteredMessageWithEmail:
        'يوجد بالفعل صاحب مسجل بهذا البريد الإلكتروني. البريد الإلكتروني {{email}} تم إنشاؤه بالفعل كصاحب. يرجى تسجيل الدخول إلى البوابة للوصول إلى حسابك.',
      tokenInvalidOrExpired: 'رمزك غير صالح أو منتهي الصلاحية',
      goToLogin: 'الذهاب لتسجيل الدخول',
    },
    pm: {
      cards: 'بطاقات',
      manageYourPayment:
        'قم بإدارة معلومات الدفع الخاصة بك. لمشاهدة تفاصيل اشتراكك الشهري، اذهب إلى الاشتراكات.',
      defaultPayment: 'الدفع الافتراضي',
      setAsDefault: 'تعيين كافتراضي',
      addCard: 'إضافة بطاقة',
      addBoleto: 'إضافة بوليتو',
      creditCard: 'بطاقة ائتمانية',
      boleto: 'بوليتو',
      add: 'إضافة',
      boletos: 'بوليتوس',
    },
    Role: 'الدور',
    Often: 'غالبًا',
    Sometimes: 'أحيانًا',
    Never: 'أبدًا',
    Date: 'تاريخ',
    CGQ: 'CGT',
    VIQ: 'VIS',
    AUQ: 'AUD',
    OLQ: 'CLO',
    BHQ: 'CMP',
    Overall: 'عام',
    Actions: 'إجراءات',
    'Holder Info': 'معلومات الحامل',
    Loading: 'جارٍ التحميل',
    Profile: 'ملف التعريف',
    Comments: 'تعليقات',
    'View Branch': 'عرض الفرع',
    'Add License to Branch': 'إضافة ترخيص للفرع',
    'Create Board': 'إنشاء لوحة',
    'Review Publication': 'مراجعة النشر',
    Creator: 'المنشئ',
    'Board History': 'تاريخ اللوحة',
    'Change Customers to Support Area': 'تغيير العملاء إلى منطقة الدعم',
    'Change Users to Support Area': 'تغيير المستخدمين إلى منطقة الدعم',
    'Change Licenses to Branch': 'تغيير التراخيص إلى فرع',
    'Tablet code': 'رمز اللوحي',
    Back: 'رجوع',
    'Livox Store': 'متجر Livox',
    Communication: 'التواصل',
    Leisure: 'الترفيه',
    Feelings: 'المشاعر',
    Hospital: 'المستشفى',
    Social: 'اجتماعي',
    'Daily Life': 'الحياة اليومية',
    Foods: 'الأغذية',
    School: 'المدرسة',
    Education: 'التعليم',
    Literacy: 'محاربة الأمية',
    Grammar: 'القواعد',
    Geography: 'الجغرافيا',
    Science: 'العلوم',
    History: 'التاريخ',
    Math: 'الرياضيات',
    Biology: 'الأحياء',
    Fun: 'المرح',
    Stories: 'قصص',
    Games: 'ألعاب',
    Game: 'لعبة',
    Memory: 'الذاكرة',
    'Questions and Answers': 'أسئلة وأجوبة',
    'Popular Items': 'العناصر الشائعة',
    'See more': 'رؤية المزيد',
    Code: 'رمز',
    'Last Modified': 'آخر تعديل',
    'Upload from .zip': 'تحميل من .zip',
    'My Boards': 'لوحاتي',
    'My Portal Boards': 'لوحاتي في البوابة',
    'Welcome {{name}}, you have {{count}} licenses':
      'مرحبًا {{name}}, لديك {{count}} تراخيص',
    'Publish one of your boards to share it with the Livox community.':
      'انشر إحدى لوحاتك لمشاركتها مع مجتمع Livox.',
    'Welcome {{name}}, you have {{count}} users':
      'مرحبًا {{name}}, لديك {{count}} مستخدم',
    'A-Z': 'أ-ي',
    Size: 'الحجم',
    Studio: 'الاستوديو',
    Favorites: 'المفضلة',
    Keyboard: 'لوحة المفاتيح',
    Import: 'استيراد',
    Assign: 'تعيين',
    'Cover Art': 'فن الغلاف',
    Title: 'عنوان',
    Description: 'وصف',
    Categories: 'فئات',
    Submitter: 'المرسل',
    'Published at': 'نشرت في',
    View: 'عرض',
    'Pending Approval': 'قيد الموافقة',
    'Holders Search': 'بحث عن حاملي التذاكر',
    'Filter Status': 'تصفية الحالة',
    'Audit Licenses': 'تدقيق التراخيص',
    'No Device': 'لا يوجد جهاز',
    'Livox Version': 'إصدار Livox',
    'Android Version': 'إصدار أندرويد',
    'Last Validation At': 'آخر تحقق في',
    Manage: 'إدارة',
    Store: 'المتجر',
    Books: 'الكتب',
    'Sign up': 'إنشاء حساب',
    Talk: 'تواصل',
    Learn: 'تعلّم',
    Admin: 'إدارة',
    'Store Admin': 'مدير المتجر',
    'Discover new boards, games and stories': 'اكتشف لوحات وألعاب وقصص جديدة',
    'Search in store': 'البحث في المتجر',
    'Search boards, games, stories...': 'ابحث عن لوحات وألعاب وقصص...',
    'Recommended content': 'المحتوى الموصى به',
    'Featured boards': 'اللوحات المميزة',
    'New content': 'محتوى جديد',
    'Featured creators': 'منشئون مميزون',
    'Sort by': 'ترتيب حسب',
    Downloads: 'التنزيلات',
    'Livox Community': 'مجتمع Livox',
    'Total downloads': 'إجمالي التنزيلات',
    'Community content': 'محتوى المجتمع',
    Follow: 'متابعة',
    Following: 'تتم المتابعة',
    'View content': 'عرض المحتوى',
    Community: 'المجتمع',
    Logout: 'تسجيل الخروج',
    'No description': 'لا يوجد وصف',
    'No Title': 'بلا عنوان',
    New: 'جديد',
    'My content': 'محتواي',
    'Unable to load your content': 'تعذر تحميل محتواك',
    'Import board': 'استيراد اللوحة',
    'Created by': 'أنشأه',
    'Board tags': 'وسوم اللوحة',
    'No tags': 'لا توجد وسوم',
    'Report content': 'الإبلاغ عن المحتوى',
    'Report reason': 'سبب البلاغ',
    Report: 'إبلاغ',
    'Report sent': 'تم إرسال البلاغ',
    'Failed to send report': 'تعذر إرسال البلاغ',
    'Offensive content': 'محتوى مسيء',
    'Inappropriate language': 'لغة غير لائقة',
    'Sexual or inappropriate content': 'محتوى جنسي أو غير لائق',
    Violence: 'العنف',
    'Hate speech': 'خطاب الكراهية',
    'Spam or advertising': 'رسائل مزعجة أو إعلانات',
    'Copyright infringement': 'انتهاك حقوق النشر',
    'Duplicate content': 'محتوى مكرر',
    'Off-topic content': 'محتوى خارج الموضوع',
    'Exposed personal data': 'بيانات شخصية مكشوفة',
    'Content deleted': 'تم حذف المحتوى',
    'Failed to delete content': 'تعذر حذف المحتوى',
    'Sending...': 'جارٍ الإرسال...',
    'New Releases': 'إصدارات جديدة',
    'Top Rated': 'الأعلى تقييمًا',
    'See all': 'عرض الكل',
    'Browse by category': 'تصفح حسب الفئة',
    'No content found': 'لم يتم العثور على محتوى',
    'Try adjusting your filters': 'حاول تعديل الفلاتر',
    'Go to slide': 'انتقل إلى الشريحة',
    'Back to Store': 'العودة إلى المتجر',
    'Loading board...': 'جارٍ تحميل اللوحة...',
    'No description provided': 'لا يوجد وصف',
    stars: 'نجوم',
    votes: 'أصوات',
    Rate: 'قيِّم',
    'Be the first to rate': 'كن أول من يقيّم',
    'In progress': 'قيد التنفيذ',
    'Tablet preview': 'معاينة الجهاز اللوحي',
    'Tablet preview coming soon': 'معاينة الجهاز اللوحي قريبًا',
    Republish: 'إعادة النشر',
    Filters: 'الفلاتر',
    Clear: 'مسح',
    Speak: 'تحدث',
    Previous: 'السابق',
    'Previous page': 'الصفحة السابقة',
    'Next page': 'الصفحة التالية',
    'Remove last': 'حذف الأخير',
    Fullscreen: 'ملء الشاشة',
    'Exit fullscreen': 'الخروج من ملء الشاشة',
    'Go to Portal': 'الذهاب إلى البوابة',
    'Sign in': 'تسجيل الدخول',
    'Sign out': 'تسجيل الخروج',
    'Open menu': 'فتح القائمة',
    'Close menu': 'إغلاق القائمة',
    Menu: 'القائمة',
    'Publication not available': 'هذا المنشور غير متاح',
    'All languages': 'جميع اللغات',
    'Switch to dark mode': 'التبديل إلى الوضع الداكن',
    'Switch to light mode': 'التبديل إلى الوضع الفاتح',
    'Toggle theme': 'تبديل المظهر',
    'Sign in to download': 'سجل الدخول للتحميل',
    'Sign in to rate': 'سجل الدخول للتقييم',
    'Author not found': 'لم يتم العثور على المؤلف',
    'Unnamed author': 'مؤلف بدون اسم',
    publication: 'منشور',
    publications: 'منشورات',
    'Boards by this author': 'لوحات هذا المؤلف',
    'Link copied to clipboard': 'تم نسخ الرابط',
    'Failed to download content': 'فشل تحميل المحتوى',
    'Download started': 'بدأ التنزيل',
    'Thanks for your vote!': 'شكرًا على تصويتك!',
    'Failed to send vote': 'فشل إرسال التصويت',
    'Content promoted': 'تمت ترقية المحتوى',
    'View profile': 'عرض الملف الشخصي',
    'Page Size': 'حجم الصفحة',
    'Licenses Search': 'البحث عن التراخيص',
    Licenses: 'التراخيص',
    'Stripe Information': 'معلومات Stripe',
    'No information': 'لا توجد معلومات',
    Canceled: 'ملغى',
    past_due: 'متأخر الدفع',
    active: 'نشط',
    'Support Areas': 'مناطق الدعم',
    Customers: 'الزبائن',
    'Livox Users': 'مستخدمو Livox',
    'Distributor Totals': 'إجماليات الموزع',
    'Portal Administration': 'إدارة البوابة',
    'My Devices': 'أجهزتي',
    'My Livox Users': 'مستخدمو Livox الخاص بي',
    'My Licenses': 'تراخيصي',
    'My Authorized Users': 'المستخدمون المصرح لهم لديّ',
    'New Customer': 'عميل جديد',
    'Notify Customer': 'إخطار العميل',
    'New Branch': 'فرع جديد',
    'New Portal User': 'مستخدم بوابة جديد',
    'Install Key': 'مفتاح التثبيت',
    'License Key': 'مفتاح الترخيص',
    'New License': 'ترخيص جديد',
    'New Registration Link': 'إنشاء رابط لتفعيل',
    'All Livox users': 'جميع مستخدمي Livox',
    Home: 'الصفحة الرئيسية',
    Customer: 'زبون',
    'My Branches': 'فروعتي',
    Branches: 'فروع',
    'Last Name': 'الاسم الأخير',
    Gender: 'الجنس',
    Age: 'العمر',
    Evaluations: 'التقييم',
    'Last Evalution': 'آخر تقييم',
    License: 'ترخيص',
    Key: 'مفتاح',
    Status: 'الحالة',
    City: 'مدينة',
    State: 'ولاية',
    Country: 'بلد',
    Available: 'متاح',
    Active: 'نشط',
    Inactive: 'غير نشط',
    Phone: 'هاتف',
    'First Name': 'الاسم الأول',
    'Device Name': 'اسم الجهاز',
    Version: 'الإصدار',
    'Remove Device': 'إزالة الجهاز',
    User: 'مستخدم',
    Contact: 'اتصال',
    Diagnosis: 'تشخيص',
    Device: 'جهاز',
    'Delete User': 'حذف المستخدم',
    'My Users': 'مستخدمو Livox',
    Expire: 'تاريخ انتهاء الصلاحية',
    Support: 'الدعم',
    Dates: 'التواريخ',
    'Expiration Date': 'تاريخ انتهاء الصلاحية',
    'Support Date': 'تاريخ الدعم',
    'Click to edit expiration date': 'انقر لتعديل تاريخ انتهاء الصلاحية',
    'Click to edit support date': 'انقر لتعديل تاريخ الدعم',
    'Expiration date updated successfully':
      'تم تحديث تاريخ انتهاء الصلاحية بنجاح',
    'Support date updated successfully': 'تم تحديث تاريخ الدعم بنجاح',
    'Failed to update expire date': 'فشل في تحديث تاريخ انتهاء الصلاحية',
    'Failed to update support date': 'فشل في تحديث تاريخ الدعم',
    'MAC Address': 'عنوان MAC',
    'Device Version': 'إصدار الجهاز',
    Name: 'الاسم',
    'Num. Licenses': 'عدد التراخيص',
    Activated: 'مفعل',
    Inactivated: 'غير مفعل',
    Email: 'البريد الإلكتروني',
    'My Auth Users': 'مستخدمو البوابة الخاص بي',
    Holder: 'حامل',
    'Customer Licenses': 'تراخيص الزبون',
    Type: 'نوع',
    Distribution: 'التوزيع',
    Language: 'اللغة',
    Reseller: 'تاجر إعادة البيع',
    Text: 'نص',
    'Number of Devices': 'عدد الأجهزة',
    'Lifetime License': 'ترخيص مدى الحياة',
    Address: 'عنوان',
    Zipcode: 'الرمز البريدي',
    Neighborhood: 'حي',
    'Contact Email': 'البريد الإلكتروني للاتصال',
    'Confirm Contact Email': 'تأكيد البريد الإلكتروني للاتصال',
    'First name': 'الاسم الأول',
    'Last name': 'الاسم الأخير',
    Group: 'مجموعة',
    Password: 'كلمة المرور',
    Male: 'ذكر',
    Female: 'أنثى',
    'My Portal Users': 'مستخدمو البوابة الخاص بي',
    'Edit Profile': 'تعديل الملف الشخصي',
    'Change Password': 'تغيير كلمة المرور',
    Register: 'تسجيل',
    'I forgot my password': 'نسيت كلمة المرور',
    Account: 'الحساب',
    'No results': 'لا توجد نتائج',
    'Customers Search': 'البحث عن الزبائن',
    Search: 'بحث',
    'Search by name or email': 'البحث بالاسم أو البريد',
    'Tree view': 'عرض شجري',
    'Table view': 'عرض جدولي',
    Download: 'تنزيل',
    'Registration Link': 'رابط التسجيل',
    Page: 'صفحة',
    of: 'من',
    results: 'نتائج',
    'View Branches': 'عرض الفروع',
    'View Users': 'عرض المستخدمين',
    Cancel: 'إلغاء',
    Create: 'إنشاء',
    'Branch Name': 'اسم الفرع',
    'Confirm Password': 'تأكيد كلمة المرور',
    'Customer Branches': 'فروع الزبون',
    'My Evaluations': 'تقييماتي',
    'Livox User': 'مستخدم Livox',
    'Add Branch': 'إضافة فرع',
    'Distributor Customers': 'زبائن الموزع',
    'New Support Area': 'منطقة دعم جديدة',
    'Assign Users': 'تعيين المستخدمين',
    'Assign Customers': 'تعيين الزبائن',
    Dashboard: 'لوحة التحكم',
    'Unique users by day': 'المستخدمون الفريدون حسب اليوم',
    'Users by language': 'المستخدمون حسب اللغة',
    'Users by country': 'المستخدمون حسب البلد',
    Devices: 'الأجهزة',
    'Manage my devices': 'إدارة أجهزتي',
    News: 'الأخبار',
    'Read more': 'اقرأ المزيد',
    'Total Licenses': 'إجمالي التراخيص',
    'Paid Licenses': 'التراخيص المدفوعة',
    'Free Licenses': 'التراخيص المجانية',
    'Distributor Stats': 'إحصائيات الموزع',
    Users: 'المستخدمون',
    Remove: 'إزالة',
    Evaluate: 'تقييم',
    'Cognitive Evaluation': 'التقييم الإدراكي',
    'Recognizes images': 'يتعرف على الصور',
    'Notion of cause and effect': 'مفهوم السبب والنتيجة',
    'Has notion of body awareness': 'يمتلك فكرة عن الوعي الجسدي',
    'Has symbolic representation': 'يمتلك تمثيل رمزي',
    'Makes choices': 'يتخذ الخيارات',
    Literate: 'مثقف',
    'Auditory Agnosia': 'اللغة السمعية',
    'Cow mooing': 'صوت البقرة',
    'Chicken clucking': 'صوت الدجاجة',
    'Dog barking': 'صوت الكلب',
    Doorbell: 'جرس الباب',
    Sirens: 'صفارات الإنذار',
    'Visual Agnosia': 'اللأغنوسي البصري',
    Dog: 'الكلب',
    Cat: 'قطة',
    Bird: 'طائر',
    House: 'منزل',
    Banana: 'موز',
    Grapes: 'عنب',
    Pineapple: 'أناناس',
    Watermelon: 'بطيخ',
    Telephone: 'هاتف',
    Car: 'سيارة',
    Shoe: 'حذاء',
    Ball: 'كرة',
    'Visual Oral Language': 'اللغة البصرية الشفوية',
    'Where is the ball?': 'أين الكرة؟',
    'Where is the doll?': 'أين الدمية؟',
    'Are you at home?': 'هل أنت في المنزل؟',
    'What is the name of your mother?': 'ما هو اسم والدتك؟',
    'What is your name?': 'ما هو اسمك؟',
    'Does he/she know his/her birthday?': 'هل يعرف تاريخ ميلاده/ميلادها؟',
    'Does he/she know his/her name?': 'هل يعرف اسمه/اسمها؟',
    'Does he/she orient to date/time?': 'هل يوجه نفسه للتاريخ/الوقت؟',
    'Can he/she follow one step directions?':
      'هل يستطيع اتباع التعليمات بخطوة واحدة؟',
    'Can he/she follow two step directions?':
      'هل يستطيع اتباع التعليمات بخطوتين؟',
    'Behavior Evaluation': 'تقييم السلوك',
    'Does he/she bite?': 'هل يعض؟',
    'Does he/she hit his/her head on the wall?': 'هل يضرب رأسه بالحائط؟',
    'Does he/she understand feelings?': 'هل يفهم المشاعر؟',
    'Does he/she sleep well?': 'هل ينام جيدًا؟',
    General: 'عام',
    'Does he/she cry?': 'هل يبكي؟',
    'Does he/she have temper tantrums?': 'هل لديه نوبات غضب؟',
    'Is he/she aggressive?': 'هل هو/هي عدواني؟',
    'Does he/she eat well?': 'هل يأكل جيدا؟',
    'Does he/she run from one place to another?': 'هل يركض من مكان لآخر؟',
    'Does he/she focus in an activity?': 'هل يركز في نشاط؟',
    'Does he/she play with other children?': 'هل يلعب مع أطفال آخرين؟',
    'Does he/she have a hard time to sleep?': 'هل يجد صعوبة في النوم؟',
    'Does he/she like to be alone?': 'هل يحب أن يكون وحيدًا؟',
    'Does he/she demonstrate joint attention?': 'هل يظهر اهتمامًا مشتركًا؟',
    'Does he/she scream?': 'هل يصرخ؟',
    'Is he/she hypersensitive to sensory stimuli?':
      'هل هو/هي حساس مفرط للمثيرات الحسية؟',
    'Is he/she unaware to sensory stimuli?':
      'هل هو/هي غير مدرك للمثيرات الحسية؟',
    Holders: 'الحاملو',
    Purcharse: 'شراء',
    Edit: 'تعديل',
    Delete: 'حذف',
    'E-mail': 'البريد الإلكتروني',
    'Full Name': 'الاسم الكامل',
    'Phone Number': 'رقم الهاتف',
    Save: 'حفظ',
    Undo: 'تراجع',
    Publish: 'نشر',
    'New Item': 'عنصر جديد',
    Attributes: 'السمات',
    'Display Text': 'نص العرض',
    'Spoken Phrase': 'عبارة منطوقة',
    'Expand image on click': 'تكبير الصورة عند النقر',
    Colors: 'الألوان',
    Pictures: 'صور',
    'Search a symbol': 'بحث عن رمز',
    'Field Changed': 'الحقل تغير',
    'Old Value': 'القيمة القديمة',
    'New Value': 'القيمة الجديدة',
    'License History': 'تاريخ الترخيص',
    Branch: 'فرع',
    'Evaluation Date': 'تاريخ التقييم',
    'Branch Licenses': 'تراخيص الفرع',
    'Add Licenses to Branch': 'إضافة تراخيص للفرع',
    Confirm: 'تأكيد',
    Close: 'إغلاق',
    'Livox version distribution': 'توزيع إصدار Livox',
    'Expires in': 'ينتهي في',
    'Support ends': 'ينتهي الدعم في',
    available: 'متاح',
    'Android OS distribution': 'توزيع نظام Android OS',
    likes: 'إعجابات',
    downloads: 'تنزيلات',
    'Reviewed at': 'مراجع في',
    Comment: 'تعليق',
    Pending: 'معلق',
    Approved: 'معتمد',
    Archived: 'مؤرشف',
    Accept: 'قبول',
    Reject: 'رفض',
    Reason: 'السبب',
    Rejected: 'مرفوض',
    'Create License Registration Link': 'إنشاء رابط تسجيل الترخيص',
    'Create separate install keys': 'إنشاء مفاتيح تثبيت منفصلة',
    'Log Out': 'تسجيل خروج',
    'Evaluate Livox User': 'تقييم مستخدم Livox',
    Billing: 'الفواتير',
    'Acquire Livox': 'احصل على Livox',
    'You are about to purchase the best alternative comunication app in the world!':
      'أنت على وشك شراء أفضل تطبيق اتصالات بديلة في العالم!',
    '1. Select a Plan': '1. اختر خطة',
    BASIC: 'أساسي',
    'Up to 3 users': 'حتى 3 مستخدمين',
    'Smart Scan': 'مسح ذكي',
    'IntelliTouch - Touch Correction': 'IntelliTouch - تصحيح اللمس',
    'Virtual keyboard': 'لوحة مفاتيح افتراضية',
    'Stock Images (20,000 images)': 'صور مخزنة (20,000 صورة)',
    'Creation of pedagogical content': 'إنشاء محتوى تربوي',
    'Voice, text and image customization': 'تخصيص الصوت والنص والصورة',
    'Content transfer between tablets': 'نقل المحتوى بين الأجهزة اللوحية',
    '/ month': '/ شهر',
    'on a yearly plan': 'في خطة سنوية',
    PLUS: 'بلاس',
    'Recommended for families': 'موصى به للعائلات',
    'New Features Update': 'تحديث الميزات الجديدة',
    'Trigger Control': 'تحكم بالمحفزات',
    'Livox control with the blink of an eye': 'تحكم Livox برمشة عين',
    'Artificially Intelligent Item Recommendations Based on Time and Location':
      'توصيات العناصر الذكية بناءً على الوقت والموقع',
    PRO: 'برو',
    'Recommended for professionals!': 'موصى به للمحترفين!',
    'UNLIMITED Users': 'عدد غير محدود من المستخدمين',
    'Complete assessment and content tool to track users progress with Livox (patients or students)':
      'أداة تقييم ومحتوى كاملة لمتابعة تقدم المستخدمين مع Livox (المرضى أو الطلاب)',
    '2. Select a payment plan': '2. اختر خطة الدفع',
    monthly: 'شهري',
    quarterly: 'ربع سنوي',
    '% off': 'خصم %',
    yearly: 'سنوي',
    '3. Confirm the value': '3. أكد القيمة',
    'per month': 'في الشهر',
    'Proceed with the checkout': 'المتابعة للخروج',
    'Select a Plan': 'اختر خطة',
    Continue: 'استمرار',
    'Get Livox': 'احصل على Livox',
    'Select a Plan - Livox Portal': 'اختر خطة - بوابة Livox',
    '1. Confirm your Plan': '1. أكد خطتك',
    '3. Confirm the plan': '3. أكد الخطة',
    Checkout: 'الخروج',
    'Secure checkout': 'دفع آمن',
    'per year': 'في السنة',
    Change: 'تغيير',
    'per quarter': 'في كل ربع',
    'Cardholder Name': 'اسم حامل البطاقة',
    'Street address': 'عنوان الشارع',
    'Apartment / Suite / Unit / Building': 'شقة / جناح / وحدة / مبنى',
    'Billing Address': 'عنوان الفواتير',
    'Payment Info': 'معلومات الدفع',
    'Credit or debit card': 'بطاقة ائتمان أو خصم',
    'Credit card info secured by': 'معلومات بطاقة الائتمان محمية بواسطة',
    'Please wait for your profile to load, or refresh the page.':
      'يرجى انتظار تحميل ملفك الشخصي أو تحديث الصفحة.',
    Success: 'نجاح',
    'Upload from .zip file here': 'ارفع من ملف .zip هنا',
    'Published Title': 'عنوان النشر',
    'Publish Content': 'نشر المحتوى',
    'Cover Image': 'صورة الغلاف',
    'Upload Image': 'تحميل صورة',
    Buy: 'شراء',
    Boards: 'لوحات',
    'Thanks for purchasing Livox': 'شكرًا لشراء Livox',
    'We are processing your payment, a receipt will be sent to':
      'نحن نقوم بمعالجة دفعتك، سيتم إرسال إيصال إلى',
    'with instructions on how to activate Livox.':
      'مع تعليمات حول كيفية تفعيل Livox.',
    'If you have any questions/issues': 'إذا كان لديك أي أسئلة أو مشاكل',
    'contact our support.': 'اتصل بدعمنا.',
    Deleted: 'محذوف',
    'You have successfully submitted this board for reviewing, please wait up to 48 hours to be approved.':
      'لقد أرسلت هذه اللوحة للمراجعة بنجاح، يرجى الانتظار حتى 48 ساعة للموافقة.',
    'You have successfully registered, Please return to the tablet to proceed.':
      'لقد قمت بالتسجيل بنجاح، يرجى العودة إلى الجهاز اللوحي للمتابعة.',
    'Validation notEmpty on coverImage failed': 'يرجى إضافة صورة إلى نشرك',
    'You are not logged in. Create your account to see more of this content':
      'أنت لست مسجل الدخول. أنشئ حسابك لمشاهدة المزيد من هذا المحتوى.',
    'Buy Livox': 'شراء Livox',
    'Select your plan and payment method to get started.':
      'اختر خطتك وطريقة الدفع للبدء.',
    'payment.pageDescription': 'اختر خطتك وطريقة الدفع لإكمال الشراء.',
    'payment.propaganda':
      'أنت على وشك شراء أفضل تطبيق اتصالات بديلة في العالم!',
    'payment.activeSubscriptionsCount': '{{count}} اشتراك نشط',
    'payment.youHaveLicenses': 'لديك تراخيص نشطة.',
    'payment.viewLicensesHere': 'عرض تراخيصك هنا',
    'payment.youHaveActiveSubscriptions': 'لديك اشتراكات نشطة.',
    'payment.viewMyAssessments': 'عرض في تقييماتي',
    'payment.viewMySubscriptions': 'عرض في اشتراكاتي',
    'payment.onlyPortugueseTitle': 'الدفع غير متاح',
    'payment.onlyPortugueseAvailable':
      'الدفع متاح بالبرتغالية فقط في الوقت الحالي.',
    'payment.blockedInBrazilTitle': 'الدفع غير متاح في منطقتك',
    'payment.blockedInBrazil':
      'الدفع عبر الإنترنت غير متاح للوصول من البرازيل.',
    'payment.blockedContactTitle': 'تواصل معنا:',
    'payment.blockedContactBrazil':
      'البرازيل\n+55 81 97108 3009 (هاتف وواتساب)\ncontato@livox.com.br\nAvenida Fagundes Varela, 950, LJ 15, CXP 1776, Jardim Atlântico, Olinda-Pe, Brasil, CEP: 53140-080',
    'payment.blockedContactUS':
      'الولايات المتحدة\n+1 (407) 449-6391\ncarlos@livox.com.br\nGrand National Drive, suite 128, Orlando, FL',
    'payment.blockedContactJordan':
      'الأردن\n00962796870058\nala.alramahi@gmail.com',
    'payment.noLicensesEncourage':
      'ليس لديك أي تراخيص. اشترِ الآن للبدء مع Livox!',
    Media: 'الوسائط',
    'Upload an image or video': 'تحميل صورة أو فيديو',
    'No image': 'لا توجد صورة',
    'Welcome to your boards page': 'مرحبًا بك في صفحة لوحاتك',
    'Assistive Tecnology': 'التكنولوجيا المساعدة',
    '1. Create': '1. إنشاء',
    'To get started use the Livox Studio to create cards, upload images, music and videos':
      'لبدء الاستخدام، استخدم استوديو Livox لإنشاء بطاقات، تحميل صور وموسيقى وفيديوهات',
    '2. Publish': '2. نشر',
    'Submit you content to be published in the store':
      'أرسل محتواك للنشر في المتجر',
    '3. Get feedback': '3. احصل على تعليقات',
    'Receive feedback and satisfaction on seeing your content being used all around the globe!':
      'تلقي ملاحظات ورضا عند رؤية المحتوى الخاص بك يُستخدم في جميع أنحاء العالم!',
    'Livox Portal': 'بوابة Livox',
    'A content store made for you!': 'متجر محتوى تم تصميمه من أجلك!',
    'The best portal of assistive technologies in the world!':
      'أفضل بوابة للتكنولوجيا المساعدة في العالم!',
    'Learn More': 'معرفة المزيد',
    'Recent Items': 'العناصر الحديثة',
    by: 'بواسطة',
    'Untitled Content': 'محتوى بلا عنوان',
    'Loading...': 'جارٍ التحميل...',
    'Click here to add a title': 'انقر هنا لإضافة عنوان',
    'Portuguese (BR)': 'البرتغالية (البرازيل)',
    English: 'الإنجليزية',
    Arabic: 'العربية',
    German: 'الألمانية',
    'No boards found': 'لم يتم العثور على لوحات',
    'Removing this device will make the user log out of the app. Are you sure you want to remove this device?':
      'إزالة هذا الجهاز ستؤدي إلى تسجيل خروج المستخدم من التطبيق. هل أنت متأكد أنك تريد إزالة هذا الجهاز؟',
    'New User': 'مستخدم جديد',
    'Login as another user': 'تسجيل الدخول كمستخدم آخر',
    Technical: 'تقني',
    Pedagogical: 'تربوي',
    Results: 'النتائج',
    'Top Rated Items': 'العناصر الأعلى تقييمًا',
    'Back to Livox Portal': 'العودة إلى بوابة Livox',
    'No Categories': 'لا توجد فئات',
    Author: 'المؤلف',
    'No votes yet': 'لا يوجد تصويت حتى الآن',
    'Rate this content': 'قيم هذا المحتوى',
    'You must be logged in to vote on this content!':
      'يجب أن تكون مسجل الدخول للتصويت على هذا المحتوى!',
    'Go to Livox Store': 'اذهب إلى متجر Livox',
    'Go to Play Store': 'اذهب إلى متجر Play',
    'Sign Up': 'اشترك',
    Login: 'تسجيل الدخول',
    'Log In': 'تسجيل الدخول',
    'License Availability': 'توفر الترخيص',
    'My Profile': 'ملفي الشخصي',
    'No description available': 'لا يوجد وصف متاح',
    Publications: 'المنشورات',
    'User Profile': 'ملف المستخدم',
    'New user': 'مستخدم جديد',
    'Livox Users Growth': 'نمو مستخدمي Livox',
    'Users Disability Distribution': 'توزيع الإعاقات للمستخدمين',
    'Users Disabilty Distribution': 'توزيع الإعاقات للمستخدمين',
    'Contact us': 'تواصل معنا',
    'Support Type': 'نوع الدعم',
    Subject: 'الموضوع',
    Message: 'رسالة',
    Send: 'إرسال',
    'License Distribution': 'توزيع التراخيص',
    'Manage my licenses': 'إدارة تراخيصي',
    'Show From': 'عرض من',
    'Only my branch': 'فرعي فقط',
    'All Branches': 'جميع الفروع',
    'Last Validation Date': 'تاريخ التحقق الأخير',
    'Device ID': 'معرف الجهاز',
    'About you': 'عنك',
    'No publications yet': 'لا توجد منشورات حتى الآن',
    'No description available.': 'لا يوجد وصف متاح.',
    'Remove this livox user? ': 'إزالة هذا المستخدم من Livox؟ ',
    'Users by city': 'المستخدمون حسب المدينة',
    'Create new customer': 'إنشاء زبون جديد',
    'Boards Search': 'بحث عن اللوحات',
    'Add a branch to': 'إضافة فرع إلى',
    'Edit Branch': 'تعديل الفرع',
    'Edit Customer': 'تعديل العميل',
    Update: 'تحديث',
    'Delete Branch': 'حذف الفرع',
    'Create Branch Administrator': 'إنشاء مدير فرع',
    'Deleting this branch will remove the users and all licenses from it. Are you sure you want to delete this branch?':
      'حذف هذا الفرع سيؤدي إلى إزالة المستخدمين وجميع التراخيص منه. هل أنت متأكد من رغبتك في حذف هذا الفرع؟',
    'Deleting this branch will transfer all users and licenses from this branch and its child branches to the parent branch.':
      'حذف هذا الفرع سينقل جميع المستخدمين والتراخيص من هذا الفرع وفروعه إلى الفرع الأب.',
    'Deleting the root branch will remove users, licenses, Livox users and holders of this customer and all its branches.':
      'حذف الفرع الرئيسي سيزيل المستخدمين والتراخيص ومستخدمي Livox وأصحاب التراخيص لهذا العميل وجميع فروعه.',
    'Are you sure you want to delete this branch?':
      'هل أنت متأكد من رغبتك في حذف هذا الفرع؟',
    'Are you sure you want to delete branch':
      'هل أنت متأكد من رغبتك في حذف الفرع',
    'Delete all users of this customer and all its branches.':
      'حذف جميع مستخدمي هذا العميل وجميع فروعه.',
    'Delete all licenses of this customer and all its branches.':
      'حذف جميع تراخيص هذا العميل وجميع فروعه.',
    'Delete all Livox users of this customer and all its branches.':
      'حذف جميع مستخدمي Livox لهذا العميل وجميع فروعه.',
    'Delete all holders of this customer and all its branches.':
      'حذف جميع أصحاب التراخيص لهذا العميل وجميع فروعه.',
    'Transfer all users from this branch and its child branches to the parent branch.':
      'نقل جميع المستخدمين من هذا الفرع وفروعه إلى الفرع الأب.',
    'Transfer all licenses from this branch and its child branches to the parent branch.':
      'نقل جميع التراخيص من هذا الفرع وفروعه إلى الفرع الأب.',
    'Remove this branch and its child branch structure.':
      'إزالة هذا الفرع وهيكل فروعه.',
    'Reset Password': 'إعادة تعيين كلمة المرور',
    'years ago': 'منذ سنوات',
    'months ago': 'منذ أشهر',
    'days ago': 'منذ أيام',
    'hours ago': 'منذ ساعات',
    'minutes ago': 'منذ دقائق',
    'seconds ago': 'منذ ثوانٍ',
    'Livox app is outdated on this device': 'تطبيق Livox قديم على هذا الجهاز',
    'Sort By...': 'ترتيب حسب...',
    'Device Android Id': 'معرف جهاز أندرويد',
    Saved: 'محفوظ',
    'Saving...': 'جارٍ الحفظ...',
    'Error! Please refresh the page.': 'خطأ! يرجى تحديث الصفحة.',
    Review: 'مراجعة',
    'Upload an audio or video': 'تحميل صوت أو فيديو',
    'All Languages': 'جميع اللغات',
    Portuguese: 'البرتغالية (البرازيل)',
    "By clicking 'Publish' you are agreeing that you have read and accepted our":
      'بالنقر على "نشر" أنت توافق على أنك قرأت وقبلت',
    'terms of use': 'شروط الاستخدام',
    'Add a shortcut...': 'إضافة اختصار...',
    ExampleShortcut: 'مثال: "ماذا تريد أن تأكل؟" للوحة الأغذية.',
    'Create voice commands to open this board on Livox app!':
      'قم بإنشاء أوامر صوتية لفتح هذه اللوحة في تطبيق Livox!',
    Shortcuts: 'الاختصارات',
    'NEW!': 'جديد!',
    NEW: 'جديد',
    'Uploading...': 'جارٍ الرفع...',
    'Processing files...': 'جارٍ معالجة الملفات... يرجى الانتظار',
    'The file you uploaded is too large.': 'الملف الذي تم تحميله كبير جدًا.',
    'Error: File too large': 'خطأ: الملف كبير جدًا',
    'Error: Sorry we just encountered an unexpected error, please try again':
      'خطأ: عذرًا، واجهنا خطأ غير متوقع، يرجى المحاولة مرة أخرى',
    'Error: The zip file appears to be corrupted or is not a Livox content':
      'خطأ: يبدو أن ملف zip تالف أو ليس من محتوى Livox',
    'Are you sure you want to delete this content?':
      'هل أنت متأكد من أنك تريد حذف هذا المحتوى؟',
    'Error: Invalid content, please make sure that the file being uploaded is a .zip file':
      'خطأ: محتوى غير صالح، يُرجى التأكد من أن الملف المحمل هو ملف .zip',
    'Get Started': 'ابدأ',
    'Record a new shortcut via voice': 'سجل اختصارًا جديدًا عبر الصوت',
    'You have blocked this website from using the Microphone.':
      'لقد قمت بحظر هذا الموقع من استخدام الميكروفون.',
    "Couldn't detect speech, please check your microphone settings.":
      'لم يتم الكشف عن الكلام، يرجى التحقق من إعدادات الميكروفون.',
    'Your browser is not compatible with the Speech Recognition API, but you can manually enter the shortcuts below':
      'المتصفح الخاص بك غير متوافق مع API التعرف على الكلام، لكن يمكنك إدخال الاختصارات يدويًا أدناه.',
    'Error while recording shortcut, please try again':
      'خطأ أثناء تسجيل الاختصار، يرجى المحاولة مرة أخرى.',
    Features: 'الميزات',
    'Voice Shortcuts': 'الاختصارات الصوتية',
    'Add shortcuts to this folder': 'إضافة اختصارات إلى هذا المجلد',
    shortcuts: 'الاختصارات',
    'You have pending reviews': 'لديك مراجعات معلقة',
    'No pending reviews': 'لا توجد مراجعات معلقة',
    'Admin Portal': 'بوابة الإدارة',
    'Log out': 'تسجيل الخروج',
    'Zip Overwrite': 'الكتابة فوق Zip',
    Share: 'مشاركة',
    'Used Licenses': 'التراخيص المستخدمة',
    'Last Registered Activity': 'آخر نشاط مسجل',
    'Interactions by time of day': 'التفاعلات حسب الوقت من اليوم',
    'Avg. Interactions / User': 'متوسط التفاعلات / المستخدم',
    Featured: 'مميز',
    'Promoted Content': 'المحتوى المروج',
    'Rate this': 'قيم هذا',
    Promote: 'ترويج',
    'Your rating': 'تقييمك',
    Play: 'تشغيل',
    'Back to Edit': 'العودة إلى التحرير',
    Next: 'التالي',
    'Inside items': 'داخل العناصر',
    Regular: 'عادي',
    'Book Mode': 'وضع الكتاب',
    Fixed: 'ثابت',
    System: 'النظام',
    Rows: 'صفوف',
    Columns: 'أعمدة',
    Display: 'عرض',
    'Page Mode': 'وضع الصفحة',
    'Text Size': 'حجم النص',
    Print: 'طباعة',
    'This dashboard is made with aggregated data across all licenses':
      'تم إنشاء هذه اللوحة باستخدام بيانات مجمعة عبر جميع التراخيص',
    ' assigned to your user': ' المعينة لمستخدمك',
    'view licenses': 'عرض التراخيص',
    'No Data': 'لا توجد بيانات',
    'Last 30 days': 'آخر 30 يومًا',
    'Last 6 months': 'آخر 6 أشهر',
    'Last year': 'العام الماضي',
    'Results for': 'نتائج ل',
    'Full Screen': 'شاشة كاملة',
    'Cards cut — navigate and paste into empty slots':
      'تم قص البطاقات — تنقل والصق في الفتحات الفارغة',
    'No empty slots to paste into': 'لا توجد فتحات فارغة للصق',
    'Cards pasted': 'تم لصق البطاقات',
    'cards still to paste': 'بطاقات لا تزال للصق',
    'ready to paste': 'جاهز للصق',
    'Paste actions': 'إجراءات الصق',
    'Cards grouped into folder': 'تم تجميع البطاقات في مجلد',
    'Select at least 2 cards to group': 'حدد بطاقتين على الأقل للتجميع',
    'New folder': 'مجلد جديد',
    Cut: 'قص',
    Copy: 'نسخ',
    Paste: 'لصق',
    'Paste Inside': 'لصق بالداخل',
    Dark: 'وضع مظلم',
    Light: 'وضع ساطع',
    'Card Properties': 'خصائص البطاقة',
    'Export PDF': 'تصدير PDF',
    'Export as PDF': 'تصدير كـ PDF',
    'Export section layout': 'التخطيط',
    'Export section content': 'المحتوى',
    'Standard layout (grid)': 'التخطيط القياسي (شبكة)',
    'Single card (1×1 full page)': 'بطاقة واحدة (1×1 صفحة كاملة)',
    'Select card to export': 'اختر البطاقة للتصدير',
    'Select a card': 'اختر بطاقة',
    'Current board (grid)': 'اللوحة الحالية (شبكة)',
    'Fixed bar only': 'الشريط الثابت فقط',
    'Board + Fixed bar': 'اللوحة + الشريط الثابت',
    'Main Board': 'اللوحة الرئيسية',
    Part: 'جزء',
    'Cut here': 'اقطع هنا',
    'Exported on': 'تصدير في',
    'Fixed Bar': 'الشريط الثابت',
    'Cut for continuous use': 'يقطع للاستخدام المستمر',
    'Audio / Video': 'الصوت / الفيديو',
    'Add an audio or video': 'أضف صوتًا أو فيديو',
    'Uploaded image': 'الصورة المحملة',
    'On touching this board show this image, if none set it will skip the action':
      'عند لمس هذه اللوحة، اعرض هذه الصورة، إذا لم يتم تعيينها فسيتم تخطي العملية',
    'Search an image': 'ابحث عن صورة',
    Suggestions: 'اقتراحات',
    Images: 'صور',
    Publication: 'النشر',
    'Manage Boards': 'إدارة اللوحات',
    'Livox Web': 'Livox ويب',
    'Settings - Display': 'الإعدادات - العرض',
    Start: 'ابدأ',
    Settings: 'الإعدادات',
    'Manage Users': 'إدارة المستخدمين',
    Voice: 'صوت',
    Controls: 'ضوابط',
    'Artificial Intelligence': 'الذكاء الاصطناعي',
    About: 'حول',
    Test: 'اختبار',
    'Voice Language': 'لغة الصوت',
    'Voice Actor': 'ممثل الصوت',
    'Voice speed': 'سرعة الصوت',
    'Pitch Rate': 'معدل النبرة',
    Preview: 'معاينة',
    'Quick chat': 'دردشة سريعة',
    'Font Size': 'حجم الخط',
    'Paging Mode': 'وضع التصفح',
    'Touch correction': 'تصحيح اللمس',
    'Time to wait between touches': 'الوقت للانتظار بين اللمسات',
    'Manually set time to prevent any further touches. Set zero seconds to disable.':
      'اضبط الوقت يدويًا لمنع أي لمسات إضافية. اضبط على صفر لتعطيل.',
    'Natural Conversation': 'المحادثة الطبيعية',
    'Trigger words': 'كلمات التنبيه',
    'Registered keywords that Livox will listen before issuing an action. Keywords are case insensitive.':
      'الكلمات المفتاحية المسجلة التي يستمع إليها Livox قبل تنفيذ الإجراء. الكلمات المفتاحية لا تميز بين الحروف الكبيرة والصغيرة.',
    'No keywords created': 'لم يتم إنشاء كلمات مفتاحية',
    'Speak navigation arrows': 'نطق أسهم التنقل',
    'Enable natural conversation': 'تمكين المحادثة الطبيعية',
    'Remote voice commands that can show appropriate boards depending on context. Requires a microphone and internet connection.':
      'الأوامر الصوتية عن بُعد التي يمكنها عرض اللوحات المناسبة بناءً على السياق. يتطلب ميكروفون واتصال بالإنترنت.',
    'Enable Intellitouch': 'تمكين Intellitouch',
    'Recommended for users with motor disabilities. Automatically detects impefect touches.':
      'موصى به للمستخدمين ذوي الإعاقات الحركية. يكتشف اللمسات غير الصحيحة تلقائيًا.',
    'Delay will be set dynamically by Intellitouch.':
      'سيتم ضبط التأخير ديناميكيًا بواسطة Intellitouch.',
    Legacy: 'تقليدي',
    'Livox5+': 'Livox 5.0+',
    'Licenses Status': 'حالة التراخيص',
    'Activity days': 'أيام النشاط',
    'Active Usage Status': 'حالة الاستخدام النشط',
    'Above Average': 'فوق المتوسط',
    'Below Average': 'أقل من المتوسط',
    'Average Interactions': 'متوسط التفاعلات: {{clicks}} نقرات.',
    'Inactive licenses are those in which no user has used Livox in the given period.':
      'التراخيص غير النشطة هي تلك التي لم يستخدم فيها أي مستخدم Livox في الفترة المحددة.',
    'Version Status': 'حالة الإصدار',
    'Devices with older Operating System (OS) versions are at risk of losing access to Livox.':
      'الأجهزة التي تحتوي على إصدارات أقدم من نظام التشغيل معرضة لخطر فقدان الوصول إلى Livox.',
    'Outdated OS': 'نظام تشغيل قديم',
    'Outdated Livox': 'Livox قديم',
    'Operational System Version': 'إصدار نظام التشغيل',
    'Device usage (%)': 'استخدام الجهاز (%)',
    'Device usage': 'استخدام الجهاز',
    'Disability distribution': 'توزيع الإعاقات',
    Period: 'الفترة',
    '30 days': '30 يومًا',
    '45 days': '45 يومًا',
    '2 months': 'شهرين',
    '6 months': '6 أشهر',
    '1 year': 'سنة واحدة',
    'Global Active Usage': 'الاستخدام النشط العالمي',
    'Percent of the users that used above and below global average ({{clicks}} clicks).':
      'نسبة المستخدمين الذين استخدموا أعلى وأقل من المتوسط العالمي ({{clicks}} نقرات).',
    'Most Active': 'الأكثر نشاطًا',
    'Least Active': 'الأقل نشاطًا',
    'The users that used 30% above and below than your average (> {{upper_limit}} and < {{lower_limit}} respectively).':
      'المستخدمون الذين استخدموا 30% أعلى وأقل من متوسطك (> {{upper_limit}} و < {{lower_limit}} على التوالي).',
    'Active users are those that had at least 1 interaction on the time period.':
      'المستخدمون النشطون هم الذين قاموا بتفاعل واحد على الأقل في الفترة الزمنية.',
    'Activity ({{days}} days)': 'النشاط ({{days}} أيام)',
    'Dashboard Charts': 'رسوم بيانية للوحة التحكم',
    'Users per disability': 'المستخدمون حسب الإعاقة',
    'Users per age': 'المستخدمون حسب العمر',
    Autism: 'التوحد',
    'Amyotrophic Lateral Sclerosis': 'التصلب الجانبي الضموري',
    'Cerebral Palsy': 'الشلل الدماغي',
    'Person without disabilities': 'شخص بدون إعاقات',
    'No physical disabilities, just unable to speak':
      'لا إعاقات جسدية، فقط غير قادر على التحدث',
    'Stroke Sequelae': 'تداعيات السكتة الدماغية',
    'Down Syndrome': 'متلازمة داون',
    'Brain Injury': 'إصابة دماغية',
    'Another motor impairment': 'إعاقة حركية أخرى',
    'Another cognitive impairment': 'إعاقة معرفية أخرى',
    'Store Statistics': 'إحصائيات المتجر',
    Creators: 'المنشئون',
    Published: 'منشور',
    'Unique Downloads': 'تنزيلات فريدة',
    Items: 'عناصر',
    'SymbolStyx usage': 'استخدام SymbolStix',
    'Uploaded Images': 'الصور المحملة',
    'Uploaded Audio/Video': 'الصوت/الفيديو المحمل',
    'Multiple images': 'صور متعددة',
    'Most used symbols': 'الرموز الأكثر استخدامًا',
    'Usage Status': 'حالة الاستخدام',
    Disclaimer: 'إخلاء مسؤولية',
    'basic plan disclaimer':
      'الترخيص الأساسي هو نسخة أبسط من Livox، مع <b>موارد أقل</b> و<b>بدون دعم فني</b>. سيتم شراؤه عادة بواسطة الآباء الذين يعرفون Livox جيدًا، ويريدون على سبيل المثال جهازًا ثانيًا بإمكانيات أقل ليستخدمه أبناؤهم في الخارج. <br/> هذه النسخة لا يُنصح بها لمن يبدأون في استخدام Livox، بل لمن يمتلكون بالفعل نسخة PLUS ويرغبون في BASIC لجهاز ثاني.',
    'Available Licenses': 'التراخيص المتاحة',
    'Unable to log in with provided credentials.':
      'لا يمكن تسجيل الدخول بالبيانات المقدمة.',
    'Renew Licenses': 'تجديد التراخيص',
    Border: 'الحدود',
    'It is not possible to access cards with more than one state':
      'لا يمكن الوصول إلى البطاقات بأكثر من حالة واحدة',
    'New state': 'حالة جديدة',
    'Only text': 'نص فقط',
    'Livox IntelliBar (Beta)': 'IntelliBar لـ Livox (بيتا)',
    'Print navigation card': 'طباعة بطاقة التصفح',
    'Board + IntelliBar': 'اللوحة + IntelliBar',
    'AI Error': 'خطأ: ',
    'Create items using AI!': 'إنشاء عناصر باستخدام الذكاء الاصطناعي!',
    'Get cards recommendations for every situation!':
      'احصل على توصيات للبطاقات لكل موقف!',
    'Examples:': 'أمثلة:',
    'Breakfast items': 'عناصر الإفطار',
    'Teeth brushing steps': 'خطوات تنظيف الأسنان',
    'Quiz option choices': 'خيارات أسئلة الاختبار',
    'and many more!': 'والكثير غيرها!',
    'Cards suggestion with AI': 'اقتراح بطاقات باستخدام الذكاء الاصطناعي',
    '{{used}} of {{limit}} used': 'تم استخدام {{used}} من {{limit}}',
    'Insufficient JandaIA coins': 'رصيد JandaIA Coins غير كافٍ',
    'Type a topic': 'اكتب موضوعًا',
    'Add card': 'إضافة بطاقة',
    'Card added to board': 'تمت إضافة البطاقة إلى اللوحة',
    'No empty slots available': 'لا توجد أماكن فارغة متاحة',
    'Failed to add card': 'فشل في إضافة البطاقة',
    'Print all pages': 'طباعة جميع الصفحات',
    "Are you sure you want to delete the card(s)? This can't be undone!":
      'هل أنت متأكد أنك تريد حذف البطاقة(البطاقات)؟ لا يمكن التراجع عن هذا!',
    'Edit Email': 'تعديل البريد الإلكتروني',
    'Already exists an user with informed email':
      'يوجد بالفعل مستخدم مسجل بالبريد الإلكتروني المقدم',
    'Default Payment': 'الدفع الافتراضي',
    'ending with': 'ينتهي بـ',
    'Expires at': 'تنتهي صلاحيته في',
    'Plan details': 'تفاصيل الخطة',
    "Passwords don't match": 'كلمات المرور لا تتطابق',
    'Password must contain at least one uppercase letter, one lowercase letter, one special character, one number, and have a minimum length of 8 characters':
      'يجب أن تحتوي كلمة المرور على حرف كبير واحد على الأقل، وحرف صغير واحد، وحرف خاص واحد، ورقم واحد، وأن يكون الطول الأدنى 8 أحرف',
    'User Already exists': 'المستخدم موجود بالفعل',
    'An email will be sent to activate the account':
      'سيتم إرسال بريد إلكتروني لتفعيل الحساب',
    'Expire month': 'شهر الانتهاء',
    'Expire year': 'سنة الانتهاء',
    'Select as default payment method': 'الاختيار كوسيلة دفع افتراضية',
    'Change Billing': 'تغيير الفوترة',
    'Change card details': 'تغيير تفاصيل البطاقة',
    activate_license: 'تنشيط الترخيص',
    'Change Livox Plan': 'تغيير خطة Livox',
    'Due next in': 'مستحقة في',
    'Cancel motive': 'سبب الإلغاء',
    'Are you sure you want to cancel the plan?':
      'هل أنت متأكد من أنك تريد إلغاء الخطة؟',
    Card: 'بطاقة',
    'My subscriptions': 'اشتراكاتي',
    Cards: 'بطاقات',
    'Welcome to Livox': 'مرحبًا بك في Livox',
    'enter your e-mail address': 'أدخل عنوان بريدك الإلكتروني',
    'enter your password': 'أدخل كلمة المرور الخاصة بك',
    'Password requirements': 'متطلبات كلمة المرور',
    'Must be at least 8 characters long': 'يجب أن يكون طوله 8 أحرف على الأقل',
    'Must include at least one uppercase letter':
      'يجب أن يتضمن حرفًا واحدًا كبيرًا على الأقل',
    'Must include at least one lowercase letter':
      'يجب أن يتضمن حرفًا صغيرًا واحدًا على الأقل',
    'Must include at least one number': 'يجب أن يتضمن رقمًا واحدًا على الأقل',
    'Must include at least one special character':
      'يجب أن يتضمن حرفًا خاصًا واحدًا على الأقل',
    'Old Password': 'كلمة المرور القديمة',
    'New Password': 'كلمة المرور الجديدة',
    'enter your old password': 'ادخل كلمة مرورك القديمة',
    'enter your new password': 'ادخل كلمة مرورك الجديدة',
    'confirm your new password': 'تأكيد كلمة المرور الجديدة',
    'Holder Information': 'معلومات الحامل',
    Client: 'العميل',
    'My Subscriptions': 'اشتراكاتي',
    'Payment Methods': 'طرق الدفع',
    'Payment History': 'تاريخ الدفع',
    'Livox Cloud': 'سحابة Livox',
    'of 1TB used': 'من 1 تيرابايت مستخدم',
    'Portal Livox': 'بوابة Livox',
    'CONGRATS!': 'تهانينا!',
    'Based on your stats you used your account':
      'بناءً على إحصاءاتك، استخدمت حسابك',
    'more than last month!': 'أكثر من الشهر الماضي!',
    'Regional Food': 'طعام إقليمي',
    Animals: 'الحيوانات',
    'The Flash Game': 'لعبة الفلاش',
    'All users': 'جميع المستخدمين',
    'All period': 'كل الفترة',
    'Last day': 'اليوم الأخير',
    'Last week': 'الأسبوع الماضي',
    'Last month': 'الشهر الماضي',
    '1 month': '1 شهر',
    'User Stats': 'إحصائيات المستخدم',
    'Play Games': 'لعب الألعاب',
    'Play Duration': 'مدة اللعب',
    '(minutes)': '(دقائق)',
    Recommendations: 'التوصيات',
    'Shared Content': 'المحتوى المشترك',
    'Total number of minutes:': 'إجمالي عدد الدقائق:',
    'Yes or No': 'نعم أو لا',
    Fruits: 'فاكهة',
    Food: 'غذاء',
    'Monthly Usage': 'الاستخدام الشهري',
    'Amount of Interactions': 'كمية التفاعلات',
    "Oops! It looks like you haven't shared any content yet.":
      'عذرًا! يبدو أنك لم تشارك أي محتوى بعد.',
    'Edit Your Profile': 'تعديل ملفك الشخصي',
    Appearance: 'المظهر',
    'Privacy Terms': 'شروط الخصوصية',
    'Service Terms': 'شروط الخدمة',
    'Password Settings': 'إعدادات كلمة المرور',
    'For up to 3 users who already know or follow up with Livox professionals.':
      'لما يصل إلى 3 مستخدمين يعرفون بالفعل أو يتابعون مع محترفي Livox.',
    '/MONTH': '/شهر',
    'Payment Method': 'طريقة الدفع',
    IntelliTouch: 'IntelliTouch',
    'Image Dataset': 'مجموعة بيانات الصور',
    'Current Plan': 'الخطة الحالية',
    'Other Subscriptions': 'اشتراكات أخرى',
    cancel: 'إلغاء',
    cpfOrCnpj: 'CPF أو CNPJ',
    processing: 'جارٍ المعالجة...',
    tryAgainIn: 'حاول مرة أخرى خلال {{seconds}} ث',
    'BASIC SUBSCRIPTION': 'الاشتراك الأساسي',
    'Basic Subscription': 'الاشتراك الأساسي',
    'See as list': 'عرض كقائمة',
    'See as grid': 'عرض كمشبك',
    'HOW IT WORKS?': 'كيف يعمل؟',
    '.zip upload': 'رفع .zip',
    'create board': 'إنشاء لوحة',
    create: 'إنشاء',
    upload: 'رفع',
    feedback: 'مراجعة',
    'To get started, use Livox Studio to create cards, upload images, music and videos!':
      'لبدء الاستخدام، استخدم Livox Studio لإنشاء بطاقات، تحميل الصور والموسيقى والفيديوهات!',
    'Submit you content to be published in the portal!':
      'أرسل محتواك ليتم نشره في البوابة!',
    'Receive feedback and satisfaction ratings knowing your boards are being used around the world!':
      'تلقي ملاحظات وتقييمات رضا تعلم أن لوحاتك تُستخدم في جميع أنحاء العالم!',
    Price: 'السعر',
    OK: 'حسنًا',
    PENDING: 'قيد الانتظار',
    DECLINED: 'مرفوض',
    ChangeLivoxPlan: 'تغيير خطة Livox',
    'Active Plans': 'الخطط النشطة',
    'Canceled Plans': 'الخطط الملغاة',
    'Are you sure you want to cancel the plan':
      'هل أنت متأكد من أنك تريد إلغاء الخطة',
    'Plan changed successfully': 'تم تغيير الخطة بنجاح',
    'Plan cancel successfully': 'تم إلغاء الخطة بنجاح',
    'Provide the reason for cancellation': 'قدم سبب الإلغاء',
    CHANGE: 'تغيير',
    paid: 'مدفوع',
    open: 'مفتوح',
    draft: 'مسودة',
    void: 'لاغٍ',
    declined: 'مرفوض',
    uncollectible: 'غير قابل للتحصيل',
    Invoices: 'الفواتير',
    'Wrong password.': 'كلمة المرور خاطئة.',
    "The two password fields didn't match.": 'حقولا كلمة المرور غير متطابقتين.',
    'Something went wrong.': 'حدث خطأ ما.',
    'Please fill in all required fields.': 'يرجى ملء جميع الحقول المطلوبة.',
    'Password changed successfully!': 'تم تغيير كلمة المرور بنجاح!',
    'Device Nickname': 'اسم مستعار للجهاز',
    'License Information': 'معلومات الترخيص',
    to: 'إلى',
    'Licenses per page': 'التراخيص لكل صفحة',
    'Choose a payment method': 'اختر طريقة الدفع',
    'Published Content': 'المحتوى المنشور',
    'View published content in the store': 'عرض المحتويات المنشورة في المتجر',
    'Payment Method changed successfully': 'تم تغيير طريقة الدفع بنجاح',
    'Device removed successfully': 'تمت إزالة الجهاز بنجاح',
    'Failed to remove device': 'فشل في إزالة الجهاز',
    Monday: 'الإثنين',
    Tuesday: 'الثلاثاء',
    Wednesday: 'الأربعاء',
    Thursday: 'الخميس',
    Friday: 'الجمعة',
    Saturday: 'السبت',
    Sunday: 'الأحد',
    'Evolution of use': 'تطور الاستخدام',
    'Use by schedule': 'الاستخدام حسب الجدول',
    '(clicks)': '(نقرات)',
    Responsible: 'المسؤول',
    Birthday: 'تاريخ الميلاد',
    Birthdate: 'تاريخ الميلاد',
    None: 'لا شيء',
    Mild: 'خفيف',
    Moderate: 'معتدل',
    'Severe (Blindness)': 'شديد (العمى)',
    Good: 'جيد',
    'Severe (Needs switch)': 'شديد (يحتاج إلى محول)',
    'Few physical limitations': 'قليل من القيود المادية',
    'Dificulties in daily activities, requires assistance':
      'صعوبات في الأنشطة اليومية، يتطلب مساعدة',
    'Almost or totally dependent': 'يعتمد كلياً أو شبه كلي',
    'Without communicative intent': 'بدون نية تواصلية',
    'Does not verbalize, but has communicative intention':
      'لا يعبر لفظيا، ولكن لديه نية تواصلية',
    'Make sounds': 'يصنع أصواتًا',
    'Makes vowel unions': 'يصنع اتحادات الحروف الصوتية',
    'Speak with very limited vocabulary (5-10 words)':
      'يتحدث بمفردات محدودة جدًا (5-10 كلمات)',
    'Speak with limited vocabulary (10-30 words)':
      'يتحدث بمفردات محدودة (10-30 كلمة)',
    'Fully communicative': 'تواصلي بالكامل',
    'Diagnosis Information': 'معلومات التشخيص',
    'Fine motor skills': 'مهارات الحركية الدقيقة',
    'Repetitive movements': 'الحركات المتكررة',
    'Hearing impairment': 'ضعف السمع',
    'Visual impairment': 'ضعف البصر',
    'Current communication': 'التواصل الحالي',
    'Autonomy level': 'مستوى الاستقلالية',
    Have: 'يمتلك',
    'Does not have': 'لا يمتلك',
    Yes: 'نعم',
    No: 'لا',
    'Customer Admin': 'إدارة الزبون',
    'Portal Admin': 'إدارة البوابة',
    'Users per page': 'المستخدمون لكل صفحة',
    Private: 'خاص',
    Organization: 'المنظمة',
    'License Usage': 'استخدام الترخيص',
    'Livox Usage': 'استخدام Livox',
    Amount: 'كمية',
    Used: 'مستخدم',
    'Users Status': 'حالة المستخدمين',
    'active users': 'المستخدمون النشطون',
    Disability: 'الإعاقة',
    'Portal Users': 'مستخدمو البوابة',
    'Last Validation': 'آخر تحقق',
    Subscriptions: 'الاشتراكات',
    'Public?': 'عام؟',
    'Avaiable?': 'متاح؟',
    'Searching for boards from all your users':
      'البحث عن لوحات من جميع المستخدمين لديك',
    'Your filters did not find results': 'المرشحات الخاصة بك لم تجد نتائج',
    'not found': 'غير موجود',
    "It looks like your users haven't created boards yet":
      'يبدو أن المستخدمين لديك لم ينشئوا لوحات بعد',
    'no boards': 'لا توجد لوحات',
    'Searching for your boards': 'البحث عن لوحاتك',
    'Find boards created by users in your organization here':
      'اعثر على اللوحات التي أنشأها المستخدمون في مؤسستك هنا',
    'Removing this devices will make the user log out of the app. Are you sure you want to remove {{count}} device?':
      'إزالة هذه الأجهزة ستؤدي إلى تسجيل خروج المستخدم من التطبيق. هل أنت متأكد أنك تريد إزالة {{count}} الجهاز؟',
    'Removing this device will make the user log out of the app. Are you sure you want to remove this devices?':
      'إزالة هذا الجهاز ستؤدي إلى تسجيل خروج المستخدم من التطبيق. هل أنت متأكد أنك تريد إزالة هذا الجهاز؟',
    '{{count}} devices removed successfully': 'تمت إزالة {{count}} جهاز بنجاح',
    '{{count}} devices failed to be removed': 'فشل في إزالة {{count}} جهاز',
    'Branch removed successfully': 'تمت إزالة الفرع بنجاح',
    'Failed to remove branch': 'فشل في إزالة الفرع',
    'Branches moved successfully': 'تم نقل الفروع بنجاح',
    'Failed to move branches': 'فشل في نقل الفروع',
    'Move branches to:': 'نقل الفروع إلى:',
    Move: 'نقل',
    'Some selected branches have sub-branches. All sub-branches will also be moved.':
      'بعض الفروع المحددة لديها فروع فرعية. سيتم نقل جميع الفروع الفرعية أيضًا.',
    'Parent Branch': 'فرع رئيسي',
    Root: 'جذر',
    'Sub-branch of': 'فرع فرعي من',
    'Branch created successfully!': 'تم إنشاء الفرع بنجاح!',
    'Email already registered': 'البريد الإلكتروني مسجل بالفعل',
    'Branch updated successfully!': 'تم تحديث الفرع بنجاح!',
    'Create Branch': 'إنشاء فرع',
    'Update Branch': 'تحديث الفرع',
    'Edit Publication': 'تعديل المنشور',
    'My Assessments': 'تقييماتي',
    'Assessments Details': 'تفاصيل التقييمات',
    Assessment: 'تقييم',
    'Assessments per page': 'التقييمات لكل صفحة',
    Finish: 'إنهاء',
    'General assessment': 'التقييم العام',
    'Temporal assessment': 'التقييم المؤقت',
    'Assessment average': 'متوسط التقييم',
    Cognitive: 'إدراكي',
    Auditory: 'سمعي',
    Visual: 'بصري',
    Oral: 'شفهي',
    Behaviour: 'السلوك',
    Geral: 'عام',
    'Add comment': 'إضافة تعليق',
    'Enter your comment for this assessment': 'أدخل تعليقك لهذا التقييم',
    'Assessment added successfully!': 'تمت إضافة التقييم بنجاح!',
    'Failed to add assessments': 'فشل في إضافة التقييم',
    'New assessment': 'تقييم جديد',
    'Customer Support': 'دعم العملاء',
    Promoted: 'مروج',
    Statistics: 'الإحصائيات',
    Details: 'التفاصيل',
    Refuse: 'رفض',
    Approve: 'موافقة',
    'Content Details': 'تفاصيل المحتوى',
    'boards per page': 'اللوحات لكل صفحة',
    'Searching for pending content...': 'البحث عن المحتوى المعلق...',
    'Searching for promoted content...': 'البحث عن المحتوى المروج...',
    'Searching for published content...': 'البحث عن المحتوى المنشور...',
    Created: 'تم الإنشاء',
    Demote: 'خفض',
    'Demote Publication': 'خفض النشر',
    'Do you want to demote this content?': 'هل تريد خفض هذا المحتوى؟',
    'Approve Publication': 'موافقة النشر',
    'Do you approve this publication?': 'هل توافق على هذا النشر؟',
    'Original language': 'اللغة الأصلية',
    'Translate into (optional)': 'الترجمة إلى (اختياري)',
    'The board was written in this language, not the one it was submitted as — the existing content will be relabeled, not translated.':
      'تمت كتابة اللوحة بهذه اللغة، وليس باللغة المحددة عند إرسالها. سيُعاد تصنيف المحتوى الحالي دون ترجمته.',
    'Reject Publication': 'رفض النشر',
    'Enter the comment for this rejection': 'أدخل التعليق لهذا الرفض',
    'Remove Publication': 'إزالة النشر',
    'Download count': 'عدد التنزيلات',
    'Successfully promoted!': 'تم الترويج بنجاح!',
    'An error occurred while promoting.': 'حدث خطأ أثناء الترويج.',
    'Upload a banner to promote this board.':
      'قم بتحميل لافتة للترويج لهذه اللوحة.',
    'Successfully published board!': 'تم نشر اللوحة بنجاح!',
    'Successfully updated board!!': 'تم تحديث اللوحة بنجاح!',
    'An error occurred while submitting.': 'حدث خطأ أثناء الإرسال.',
    'Increase the description to at least 10 characters.':
      'زِد الوصف ليصبح 10 أحرف على الأقل.',
    'Publish board': 'نشر اللوحة',
    'Board submitted for review!': 'تم إرسال اللوحة للمراجعة!',
    'Please upload a cover image.': 'يرجى تحميل صورة غلاف.',
    'The board will be reviewed by an administrator before it appears in the store.':
      'ستتم مراجعة اللوحة من قِبل مسؤول قبل ظهورها في المتجر.',
    'Enter description': 'أدخل الوصف',
    'Enter title': 'أدخل العنوان',
    'Enter subtitle': 'أدخل العنوان الفرعي',
    Subtitle: 'العنوان الفرعي',
    'Email successfully sent!!!': 'تم إرسال البريد الإلكتروني بنجاح!',
    'Error sending email!': 'خطأ في إرسال البريد الإلكتروني!',
    'The content has been demoted!': 'تم خفض المحتوى!',
    'Failed to demote content!': 'فشل في خفض المحتوى!',
    'Publication successfully approved!': 'تمت الموافقة على النشر بنجاح!',
    'Failed to approve!': 'فشل في الموافقة!',
    'Publication successfully rejected!': 'تم رفض النشر بنجاح!',
    'Failed to reject!': 'فشل في الرفض!',
    Activity: 'النشاط',
    'License Activity': 'نشاط الترخيص',
    'Active Licenses': 'التراخيص النشطة',
    'Inactive Licenses': 'التراخيص غير النشطة',
    'User Activity': 'نشاط المستخدمين',
    'Removing this sponsor will revoke access to the dashboard and clear all licenses assigned to them.':
      'إزالة هذا الراعي ستلغي الوصول إلى لوحة التحكم وتزيل جميع التراخيص المخصصة لهم.',
    'Are you sure you want to delete this sponsor?':
      'هل أنت متأكد من أنك تريد حذف هذا الراعي؟',
    'The sponsor has been deleted!': 'تم حذف الراعي!',
    'Failed to remove sponsor!': 'فشل في إزالة الراعي!',
    'Sponsor created successfully!': 'تم إنشاء الراعي بنجاح!',
    'Create Sponsor': 'إنشاء راعي',
    'enter sponsor name...': 'أدخل اسم الراعي...',
    'enter email...': 'أدخل البريد الإلكتروني...',
    'New Sponsor': 'راعي جديد',
    Sponsors: 'الرعاة',
    'Projects Details': 'تفاصيل المشاريع',
    'Project Dashboard': 'لوحة تحكم المشروع',
    'Sponsors per page': 'الرعاة لكل صفحة',
    'Assign Licenses': 'تعيين التراخيص',
    '{{count}} licenses successfully assigned':
      'تم تعيين {{count}} ترخيص بنجاح',
    'Failed to assign licenses': 'فشل في تعيين التراخيص',
    'Assign licenses to sponsor': 'تعيين التراخيص للراعي',
    'Sponsor Licenses': 'رخص الرعاة',
    'Sponsored Projects': 'المشاريع الممولة',
    'Remove Licenses': 'إزالة التراخيص',
    'Remove licenses from sponsor': 'إزالة التراخيص من الراعي',
    '{{count}} licenses successfully removed':
      'تمت إزالة {{count}} ترخيص بنجاح',
    'Failed to remove licenses': 'فشل في إزالة التراخيص',
    'Create Portal User': 'إنشاء مستخدم بوابة',
    'enter first name...': 'أدخل الاسم الأول...',
    'enter last name...': 'أدخل الاسم الأخير...',
    'enter a password...': 'أدخل كلمة مرور...',
    'You do not have active plans': 'ليس لديك خطط نشطة',
    'You do not have canceled plans': 'ليس لديك خطط ملغاة',
    'searching for your payment methods': 'البحث عن طرق الدفع الخاصة بك',
    'You have no payment methods': 'ليس لديك طرق دفع',
    failed: 'فشل',
    'Your token is invalid or has expired':
      'الرمز الخاص بك غير صالح أو انتهت صلاحيته',
    'Password does not meet the minimum security requirements':
      'كلمة المرور لا تفي بالحد الأدنى من متطلبات الأمان',
    'Passwords do not match.': 'كلمات المرور غير متطابقة.',
    'Resetting...': 'إعادة تعيين...',
    'validating your token': 'التحقق من صحة الرمز الخاص بك',
    'Password successfully changed!': 'تم تغيير كلمة المرور بنجاح!',
    'Error changing password!': 'خطأ في تغيير كلمة المرور!',
    'enter branch name': 'أدخل اسم الفرع',
    'enter branch address': 'أدخل عنوان الفرع',
    'enter customer name': 'أدخل اسم العميل',
    'enter customer address': 'أدخل عنوان العميل',
    'enter city': 'أدخل المدينة',
    'enter zip code': 'أدخل الرمز البريدي',
    'enter state': 'أدخل الولاية',
    'enter phone number': 'أدخل رقم الهاتف',
    'Unauthorized Access': 'وصول غير مصرح به',
    'You do not have permission to view this page with your current role.':
      'ليس لديك إذن لعرض هذه الصفحة بالدور الحالي لك.',
    'Page Not Found': 'الصفحة غير موجودة',
    'Sorry, the page you are looking for doesn’t exist.':
      'عذرًا، الصفحة التي تبحث عنها غير موجودة.',
    'Este campo não pode ser em branco.': 'هذا الحقل لا يمكن أن يكون فارغًا.',
    'no licenses': 'لا توجد تراخيص',
    'You do not have any licenses available.': 'ليس لديك أي تراخيص متاحة.',
    licenses: 'التراخيص',
    users: 'المستخدمون',
    Quantity: 'الكمية',
    Indicator: 'المؤشر',
    Value: 'القيمة',
    Category: 'الفئة',
    Aggregate: 'إجمالي',
    'Customers per page': 'العملاء لكل صفحة',
    'Holders per page': 'الحاملو لكل صفحة',
    'Searching for your licenses': 'البحث عن تراخيصك',
    'There are no promoted boards': 'لا توجد لوحات مروجة',
    'There are no pending boards': 'لا توجد لوحات معلقة',
    'No data was found for this chart.':
      'لم يتم العثور على بيانات لهذا الرسم البياني.',
    Sponsor: 'الراعي',
    'My Projects': 'مشاريعي',
    'Invalid Date': 'تاريخ غير صالح',
    'Organization Details': 'تفاصيل الجهة المنظمة',
    'All Licenses': 'جميع التراخيص',
    'All License Types': 'جميع أنواع التراخيص',
    'Select Branch': 'اختر فرع',
    'Unlink License': 'إلغاء ربط الترخيص',
    'Licenses transferred with success!': 'تم نقل التراخيص بنجاح!',
    'Error in transfer!': 'خطأ في النقل!',
    'An unexpected error occurred!': 'حدث خطأ غير متوقع!',
    'Transfer licenses to:': 'نقل التراخيص إلى:',
    'When deleting this user from the Portal, they will remain available on your Livox tablet. If you don’t want this user’s data to be sent back to the Portal, delete them from your tablet as well.':
      'عند حذف هذا المستخدم من البوابة، سيظل متاحًا على جهاز Livox اللوحي الخاص بك. إذا كنت لا تريد إرسال بيانات هذا المستخدم مرة أخرى إلى البوابة، احذفه من جهازك اللوحي أيضًا.',
    'The Livox User has been deleted!': 'تم حذف مستخدم Livox!',
    'Failed to remove Livox User!': 'فشل في إزالة مستخدم Livox!',
    'Delete Livox User': 'حذف مستخدم Livox',
    'Are you sure you want to delete this livox user?':
      'هل أنت متأكد من أنك تريد حذف هذا المستخدم من Livox؟',
    'Activate with QRCode': 'تفعيل باستخدام QRCode',
    'Enter a valid holder email': 'أدخل بريد إلكتروني صالح للحامل',
    'To activate this license, enter the email of an associated holder.':
      'لتفعيل هذا الترخيص، أدخل البريد الإلكتروني لحامل مرتبط.',
    'Holder Email': 'البريد الإلكتروني للحامل',
    'Invalid email or not associated with this license.':
      'البريد الإلكتروني غير صالح أو غير مرتبط بهذا الترخيص.',
    Validate: 'تحقق',
    'Activate with QRCode in your Livox app':
      'تفعيل باستخدام QRCode في تطبيق Livox الخاص بك',
    Distributor: 'الموزع',
    'Distributor Admin': 'إدارة الموزع',
    'Distributor Support': 'دعم الموزع',
    'Create Support Area': 'إنشاء منطقة دعم',
    'enter support area name...': 'أدخل اسم منطقة الدعم...',
    'Support area created successfully!': 'تم إنشاء منطقة الدعم بنجاح!',
    'Removing this support area will only unlink customers and users from this area.':
      'إزالة هذه المنطقة الدعم ستؤدي فقط إلى إلغاء ربط العملاء والمستخدمين من هذه المنطقة.',
    'Are you sure you want to delete this support area?':
      'هل أنت متأكد أنك تريد حذف منطقة الدعم هذه؟',
    'The support area has been deleted!': 'تم حذف منطقة الدعم!',
    'Failed to remove support area!': 'فشل في إزالة منطقة الدعم!',
    'Support Area Users': 'مستخدمو منطقة الدعم',
    'Remove Users': 'إزالة المستخدمين',
    'Remove users from support area': 'إزالة المستخدمين من منطقة الدعم',
    'Failed to remove users': 'فشل في إزالة المستخدمين',
    'Select Users': 'اختر المستخدمين',
    '{{count}} users successfully removed': 'تمت إزالة {{count}} مستخدم بنجاح',
    'Support Area Customers': 'عملاء منطقة الدعم',
    'Select Customers': 'اختر العملاء',
    'Customers added successfully!': 'تمت إضافة العملاء بنجاح!',
    'Remove Customers': 'إزالة العملاء',
    '{{count}} customers successfully removed':
      'تمت إزالة {{count}} عميل بنجاح',
    'Failed to remove customers': 'فشل في إزالة العملاء',
    'Remove customers from support area': 'إزالة العملاء من منطقة الدعم',
    Add: 'إضافة',
    'Support Areas per page': 'مناطق الدعم لكل صفحة',
    'Created at': 'تاريخ الإنشاء',
    'Confirm delete': 'تأكيد الحذف',
    'Android Versions': 'إصدارات أندرويد',
    'Create Android Version': 'إنشاء إصدار أندرويد',
    'Edit Android Version': 'تعديل إصدار أندرويد',
    'New Android Version': 'إصدار أندرويد جديد',
    'Android version created successfully!': 'تم إنشاء إصدار أندرويد بنجاح!',
    'Android version updated successfully!': 'تم تحديث إصدار أندرويد بنجاح!',
    'The android version has been deleted!': 'تم حذف إصدار أندرويد!',
    'Failed to remove android version!': 'فشل في حذف إصدار أندرويد!',
    'Are you sure you want to delete this android version?':
      'هل أنت متأكد أنك تريد حذف إصدار أندرويد هذا؟',
    'Android Versions per page': 'إصدارات أندرويد لكل صفحة',
    Resellers: 'الموزعون',
    'Create Reseller': 'إنشاء موزع',
    'Edit Reseller': 'تعديل الموزع',
    'New Reseller': 'موزع جديد',
    'enter reseller name...': 'أدخل اسم الموزع...',
    'Reseller created successfully!': 'تم إنشاء الموزع بنجاح!',
    'Reseller updated successfully!': 'تم تحديث الموزع بنجاح!',
    'The reseller has been deleted!': 'تم حذف الموزع!',
    'Failed to remove reseller. Make sure there are no licenses linked to it before deleting.':
      'فشل حذف الموزع. تأكد من عدم وجود تراخيص مرتبطة به قبل الحذف.',
    'Are you sure you want to delete this reseller?':
      'هل أنت متأكد أنك تريد حذف هذا الموزع؟',
    'Resellers per page': 'الموزعون لكل صفحة',
    'Payment QR Code': 'رمز QR للدفع',
    'Payment link for {{name}}': 'رابط الدفع لـ {{name}}',
    'Payment link': 'رابط الدفع',
    'User created successfully!': 'تم إنشاء المستخدم بنجاح!',
    Spanish: 'إسباني',
    French: 'فرنسي',
    Italian: 'إيطالي',
    'Billing user does not exist': 'مستخدم الفواتير غير موجود',
    'Our website has been updated to improve your experience. To ensure proper functionality, we recommend clearing your browser cache. If you are using the Livox app version 5, please close and reopen the app to ensure proper connection to your account.':
      'لقد تم تحديث موقعنا الإلكتروني لتحسين تجربتك. لضمان الأداء السليم، نوصي بمسح ذاكرة التخزين المؤقت للمتصفح. إذا كنت تستخدم تطبيق Livox الإصدار 5، يرجى إغلاق التطبيق وإعادة فتحه لضمان الاتصال المناسب بحسابك.',
    'Website Update': 'تحديث الموقع',
    'Reload page': 'إعادة تحميل الصفحة',
    "Don't show again": 'لا تظهر مرة أخرى',
    'enter email': 'أدخل البريد الإلكتروني',
    'Customer created successfully!': 'تم إنشاء العميل بنجاح!',
    'Enter a valid email address': 'أدخل عنوان بريد إلكتروني صالح',
    'Only letters are allowed': 'يسمح فقط بالحروف',
    'enter number of devices': 'أدخل عدد الأجهزة',
    'enter text': 'أدخل نصًا',
    'enter install key...': 'أدخل مفتاح التثبيت...',
    'enter device name...': 'أدخل اسم الجهاز...',
    'enter device nickname...': 'أدخل لقب الجهاز...',
    'enter device MAC address...': 'أدخل عنوان MAC للجهاز...',
    'Device MAC Address': 'عنوان MAC للجهاز',
    'Licenses created successfully!': 'تم إنشاء التراخيص بنجاح!',
    Payment: 'الدفع',
    'Registration link generated successfully!': 'تم إنشاء رابط التسجيل بنجاح!',
    'Failed to generate registration link.': 'فشل في إنشاء رابط التسجيل.',
    'Copy Link': 'نسخ الرابط',
    'Link copied to clipboard!': 'تم نسخ الرابط إلى الحافظة!',
    '{{diff}} year(s) ago': 'منذ {{diff}} سنة/سنوات',
    '{{diff}} month(s) ago': 'منذ {{diff}} شهر/أشهر',
    '{{diff}} day(s) ago': 'منذ {{diff}} يوم/أيام',
    '{{diff}} hour(s) ago': 'منذ {{diff}} ساعة/ساعات',
    '{{diff}} minute(s) ago': 'منذ {{diff}} دقيقة/دقائق',
    'Holder registered successfully!': 'تم تسجيل الحامل بنجاح!',
    'Register Holder': 'تسجيل حامل',
    'enter address': 'أدخل العنوان',
    'confirm your password': 'تأكيد كلمة المرور',
    'Passwords must match': 'يجب أن تتطابق كلمات المرور',
    'Professional Type': 'نوع المحترف',
    'Speech Therapist': 'أخصائي النطق',
    'Occupational Therapist': 'أخصائي العلاج المهني',
    Physiotherapist: 'أخصائي العلاج الطبيعي',
    Teacher: 'معلم',
    Pedagogue: 'معلم',
    Psychopedagogue: 'أخصائي نفسي تربوي',
    Other: 'آخر',
    'Error loading subscription details': 'خطأ في تحميل تفاصيل الاشتراك',
    Activation: 'تفعيل',
    Cancellation: 'إلغاء',
    'Due Date': 'تاريخ الإنتهاء',
    'Payment Link': 'رابط الدفع',
    Receipt: 'الفاتورة',
    'View Receipt': 'عرض الفاتورة',
    'Invoice Date': 'تاريخ الفاتورة',
    Paid: 'مدفوع',
    'Invoice Status': 'حالة الفاتورة',
    'Receipt Link': 'رابط الفاتورة',
    'Status updated successfully': 'تم تحديث الحالة بنجاح',
    'Failed to update license status': 'فشل في تحديث حالة الترخيص',
    'Edit License': 'تعديل الترخيص',
    'Are you sure you want to delete this license?':
      'هل أنت متأكد أنك تريد حذف هذا الترخيص؟',
    'Are you sure you want to delete license':
      'هل أنت متأكد أنك تريد حذف الترخيص',
    'This will delete all licenses with install key: {{installKey}}':
      'سيؤدي هذا إلى حذف جميع التراخيص بمفتاح التثبيت: {{installKey}}',
    'Permanently delete the license(s)': 'حذف الترخيص(ات) بشكل دائم',
    'License deleted successfully!': 'تم حذف الترخيص بنجاح!',
    'Failed to delete license!': 'فشل في حذف الترخيص!',
    'License updated successfully!': 'تم تحديث الترخيص بنجاح!',
    'Failed to update license!': 'فشل في تحديث الترخيص!',
    'No changes to save': 'لا توجد تغييرات للحفظ',
    'Are you sure you want to update all licenses?':
      'هل أنت متأكد أنك تريد تحديث جميع التراخيص؟',
    'This will update all licenses with install key':
      'سيؤدي هذا إلى تحديث جميع التراخيص بمفتاح التثبيت',
    'Update install key to': 'تحديث مفتاح التثبيت إلى',
    'Update type to': 'تحديث النوع إلى',
    'All licenses with this install key will be affected!':
      'ستتأثر جميع التراخيص بمفتاح التثبيت هذا!',
    'Click here': 'اضغط هنا',
    Donation: 'تبرع',
    Sale: 'بيع',
    Evaluation: 'تقييم',
    Research: 'بحث',
    'Old Version (BETA TEST)': 'الإصدار القديم (TEST BETA)',
    Developer: 'مطور',
    Representative: 'ممثل',
    'Resale Channel': 'قناة بيع',
    'Are you sure you want to unblock this customer?':
      'هل أنت متأكد من أنك تريد إلغاء الحظر على هذا العميل؟',
    'Are you sure you want to block this customer?':
      'هل أنت متأكد من أنك تريد حظر هذا العميل؟',
    Block: 'حظر',
    'Confirm Exit': 'تأكيد الخروج',
    'Are you sure you want to exit? Any unsaved changes will be lost.':
      'هل أنت متأكد من أنك تريد الخروج؟ سيتم فقدان أي تغييرات غير محفوظة.',
    Export: 'تصدير',
    'Export Charts': 'تصدير الرسوم البيانية',
    'Export Charts to PDF': 'تصدير الرسوم البيانية إلى PDF',
    'Export Data': 'تصدير البيانات',
    'Exporting...': 'جارٍ التصدير...',
    'No data to export': 'لا توجد بيانات للتصدير',
    'No charts found to export': 'لم يتم العثور على رسوم بيانية للتصدير',
    'File exported successfully': 'تم تصدير الملف بنجاح',
    'Charts exported successfully': 'تم تصدير الرسوم البيانية بنجاح',
    'Export successful!': 'تم التصدير بنجاح!',
    'Export failed!': 'فشل التصدير!',
    'Error exporting file': 'خطأ في تصدير الملف',
    Select: 'اختر',
    'Unit manager': 'مدير الوحدة',
    'type to search': 'اكتب للبحث',
    'Manager e-mail': 'البريد الإلكتروني للمدير',
    'Create user': 'إنشاء مستخدم',
    'Cancel user creation': 'إلغاء إنشاء المستخدم',
    'Select existing user': 'اختر مستخدم موجود',
    'enter password': 'أدخل كلمة المرور',
    'confirm password': 'تأكيد كلمة المرور',
    'Select a manager or create a new user':
      'اختر مديرًا أو أنشئ مستخدمًا جديدًا',
    'Email not found. Click Create user':
      'البريد الإلكتروني غير موجود. انقر على إنشاء مستخدم',
    'This email already exists. Select an existing user':
      'هذا البريد الإلكتروني موجود بالفعل. اختر مستخدمًا موجودًا',
    'Customer email already registered.':
      'البريد الإلكتروني للعميل مسجل بالفعل.',
    'Email is required': 'البريد الإلكتروني مطلوب',
    'Invalid value': 'قيمة غير صالحة',
    'This field is required': 'هذا الحقل مطلوب',
    'Password is required': 'كلمة المرور مطلوبة',
    'Error exporting charts': 'خطأ في تصدير الرسوم البيانية',
    'Are you sure you want to delete this user?':
      'هل أنت متأكد من حذف هذا المستخدم؟',
    'Are you sure you want to delete user': 'هل أنت متأكد من حذف المستخدم',
    'This action will:': 'سيؤدي هذا الإجراء إلى:',
    'Unlink all licenses from the user holder':
      'إلغاء ربط جميع التراخيص من حامل المستخدم',
    'Delete the associated holder (if exists)':
      'حذف الحامل المرتبط (إذا كان موجودًا)',
    'Remove user from all groups': 'إزالة المستخدم من جميع المجموعات',
    'Delete all Livox Users linked to this user':
      'حذف جميع مستخدمي Livox المرتبطين بهذا المستخدم',
    'Permanently delete the user account': 'حذف حساب المستخدم نهائيًا',
    'This action cannot be undone!': 'لا يمكن التراجع عن هذا الإجراء!',
    'User updated successfully!': 'تم تحديث المستخدم بنجاح!',
    'User deleted successfully!': 'تم حذف المستخدم بنجاح!',
    '{{count}} licenses unlinked.': 'تم إلغاء ربط {{count}} تراخيص.',
    'Holder deleted.': 'تم حذف الحامل.',
    'Failed to delete user!': 'فشل حذف المستخدم!',
    'Changing password for user': 'تغيير كلمة المرور للمستخدم',
    'enter new password...': 'أدخل كلمة المرور الجديدة...',
    'confirm new password...': 'تأكيد كلمة المرور الجديدة...',
    'Update Password': 'تحديث كلمة المرور',
    'Password updated successfully!': 'تم تحديث كلمة المرور بنجاح!',
    'confirm your password...': 'تأكيد كلمة المرور...',
    'Edit Portal User': 'تحرير مستخدم بوابة',
    'User Details': 'تفاصيل المستخدم',
    'Personal Data': 'البيانات الشخصية',
    'View Details': 'عرض التفاصيل',
    'View Holder Details': 'عرض تفاصيل الحامل',
    'View Boards': 'عرض اللوحات',
    'View Content Store': 'عرض متجر المحتوى',
    'Created boards': 'اللوحات المنشأة',
    Total: 'المجموع',
    'Published boards': 'اللوحات المنشورة',
    'No holder linked': 'لا يوجد حامل مرتبط',
    'No customer linked': 'لا يوجد عميل مرتبط',
    'User Boards': 'لوحات المستخدم',
    'View boards created by this user': 'عرض اللوحات التي أنشأها هذا المستخدم',
    'Customer not found': 'العميل غير موجود',
    'Loading boards': 'تحميل اللوحات',
    "This user hasn't created any boards yet":
      'هذا المستخدم لم ينشئ أي لوحات بعد',
    'Create Holder': 'إنشاء حامل',
    'Edit Holder': 'تعديل الحامل',
    'Holder created successfully!': 'تم إنشاء الحامل بنجاح!',
    'No user found for this email. Fill in the fields below to create a new holder user.':
      'لم يتم العثور على مستخدم بهذا البريد الإلكتروني. املأ الحقول أدناه لإنشاء مستخدم حامل جديد.',
    'Holder updated successfully!': 'تم تحديث الحامل بنجاح!',
    'Holder deleted successfully!': 'تم حذف الحامل بنجاح!',
    'Are you sure you want to delete this holder?':
      'هل أنت متأكد من حذف هذا الحامل؟',
    'Are you sure you want to delete holder': 'هل أنت متأكد من حذف الحامل',
    'Release all licenses from this holder':
      'إطلاق جميع التراخيص من هذا الحامل',
    'Permanently delete the holder': 'حذف الحامل نهائيًا',
    '{{count}} licenses released.': 'تم إطلاق {{count}} تراخيص.',
    'Failed to delete holder!': 'فشل حذف الحامل!',
    'User is required': 'المستخدم مطلوب',
    'Country is required': 'البلد مطلوب',
    'Zipcode is required': 'الرمز البريدي مطلوب',
    'Phone number is required': 'رقم الهاتف مطلوب',
    'enter zipcode...': 'أدخل الرمز البريدي...',
    'enter address...': 'أدخل العنوان...',
    'enter city...': 'أدخل المدينة...',
    'enter state...': 'أدخل الولاية...',
    'enter phone number...': 'أدخل رقم الهاتف...',
    'enter professional record...': 'أدخل السجل المهني...',
    'Professional Record': 'السجل المهني',
    'Holder Details': 'تفاصيل الحامل',
    'Professional Information': 'المعلومات المهنية',
    'No licenses linked': 'لا توجد تراخيص مرتبطة',
    'Livox User Details': 'تفاصيل مستخدم Livox',
    'Personal Information': 'المعلومات الشخصية',
    'Health Information': 'معلومات الصحة',
    'Contact Information': 'معلومات الاتصال',
    'Responsible Information': 'معلومات الشخص المسؤول',
    'Responsible 1 Name': 'اسم المسؤول 1',
    'Responsible 1 Email': 'بريد المسؤول 1',
    'Responsible 1 Phone': 'هاتف المسؤول 1',
    'Responsible 2 Name': 'اسم المسؤول 2',
    'Responsible 2 Email': 'بريد المسؤول 2',
    'Responsible 2 Phone': 'هاتف المسؤول 2',
    'Autonomy Level': 'مستوى الاستقلالية',
    'Current Communication': 'التواصل الحالي',
    'Visual Impairment': 'ضعف البصر',
    'Fine Motor Skills': 'مهارات الحركة الدقيقة',
    'Repetitive Movements': 'الحركات المتكررة',
    'Hearing Impairment': 'ضعف السمع',
    'No data available': 'لا توجد بيانات متاحة',
    'Edit Livox User': 'تعديل مستخدم Livox',
    Unauthorized: 'غير مصرح',
    'Board settings': 'إعدادات اللوحة',
    'Board name and cover': 'اسم اللوحة والغلاف',
    'Board name': 'اسم اللوحة',
    'Board cover image': 'صورة غلاف اللوحة',
    'Board cover': 'غلاف اللوحة',
    'Click the image to change': 'انقر على الصورة للتغيير',
    'Error uploading image': 'خطأ في رفع الصورة',
    'Error saving title': 'خطأ في حفظ الاسم',
    'Move cards': 'نقل البطاقات',
    'Select cards': 'تحديد البطاقات',
    Redo: 'إعادة',
    Help: 'مساعدة',
    Layout: 'التخطيط',
    'Board background color': 'لون خلفية اللوحة',
    'Card settings': 'إعدادات البطاقة',
    'Fixed bar settings': 'إعدادات الشريط الثابت',
    'Lock board horizontal': 'قفل اللوحة أفقيًا',
    'Auto navigation cards': 'بطاقات التنقل التلقائي',
    back: 'رجوع',
    'Select background color': 'اختر لون الخلفية',
    'General card settings': 'الإعدادات العامة للبطاقات',
    'Show text only': 'عرض النص فقط',
    'Text position': 'موضع النص',
    Bottom: 'أسفل',
    Top: 'أعلى',
    'Show cards with levels as folders': 'عرض البطاقات ذات المستويات كمجلدات',
    'High contrast cards': 'بطاقات تباين عالٍ',
    'Black and white cards': 'بطاقات بالأبيض والأسود',
    IntelliBar: 'IntelliBar',
    'Enable IntelliBar': 'تفعيل IntelliBar',
    'IntelliBar description':
      'عند التفعيل، يعرض Livox شريطًا في أعلى الشاشة يمكن للمستخدم إنشاء جمل من خلاله. تتطلب هذه الميزة تنزيل لوحة بطاقات المحادثة «IntelliBar» إذا لم تكن قد فعلت ذلك بعد.',
    'IntelliBar screen size': 'حجم IntelliBar على الشاشة',
    'Speak card when adding to IntelliBar':
      'قراءة البطاقة عند إضافتها إلى IntelliBar',
    Disabled: 'معطّل',
    Enabled: 'مُفعّل',
    'Partially enabled': 'مُفعّل جزئيًا',
    intelibar_speak_disabled_desc:
      'لن يتحدث Livox إلا عند الضغط على زر التحدث في شريط الذكاء.',
    intelibar_speak_partial_desc:
      'سيتحدث Livox بالبطاقة المضغوطة التي تُدرج في شريط الذكاء.',
    intelibar_speak_full_desc: 'سيتحدث Livox بكل بطاقة مضغوطة.',
    'Speak card before adding': 'قراءة البطاقة قبل الإضافة',
    'Speak card after adding': 'قراءة البطاقة بعد الإضافة',
    'Show only card text in IntelliBar': 'عرض نص البطاقة فقط في IntelliBar',
    'Enable fixed bar': 'تفعيل الشريط الثابت',
    'Fixed bar scroll up': 'تمرير الشريط الثابت لأعلى',
    'Fixed bar scroll down': 'تمرير الشريط الثابت لأسفل',
    'Fixed bar scroll left': 'تمرير الشريط الثابت لليسار',
    'Fixed bar scroll right': 'تمرير الشريط الثابت لليمين',
    'Fixed bar limit reached': 'تم الوصول إلى الحد الأقصى للشريط الثابت',
    Position: 'الموضع',
    Side: 'جانبي',
    'Visible cards count': 'عدد البطاقات المرئية',
    'Show as folder': 'عرض كمجلد',
    'Select card bar color': 'اختر لون شريط البطاقات',
    'Create a Card': 'إنشاء بطاقة',
    Image: 'صورة',
    'Text/Spoken text': 'نص / نص منطوق',
    'Color Background': 'لون الخلفية',
    'Add media': 'إضافة وسائط',
    'Image Bank': 'بنك الصور',
    'Search image': 'بحث عن صورة',
    'Starts with': 'يبدأ بـ',
    'Card title': 'عنوان البطاقة',
    'Spoken Text': 'النص المنطوق',
    'Letters; Numbers': 'أحرف؛ أرقام',
    'Text/Spoken Text': 'نص / نص منطوق',
    card_title_description: 'سيظهر هذا النص على البطاقة.',
    'Spoken text': 'نص منطوق',
    spoken_text_description:
      'سيتم قراءة هذا النص. يمكنك كتابة نصوص طويلة إذا أردت.',
    'Text font': 'خط النص',
    'Text color': 'لون النص',
    'Background Color': 'لون الخلفية',
    'Background color card': 'لون خلفية البطاقة',
    'Card border color': 'لون حدود البطاقة',
    'Attach a media': 'إرفاق وسائط',
    'No media': 'لا توجد وسائط',
    'Record an audio': 'تسجيل صوت',
    'Pick an audio': 'اختيار صوت',
    'Pick a video': 'اختيار فيديو',
    'Cards Properties': 'خصائص البطاقات',
    'Show just text': 'عرض النص فقط',
    show_just_text_desc:
      'إذا تم التفعيل، لن يعرض Livox بعد الآن بطاقات تحتوي على صورة',
    'Large size images': 'صور بحجم كبير',
    large_images_desc: 'إذا تم التفعيل، ستظهر البطاقات أكبر',
    'Keep the card unchanged': 'إبقاء البطاقة دون تغيير',
    keep_unchanged_desc:
      'لن تتغير هذه البطاقة على اللوحات ذات القيم الافتراضية',
    'Display card in folder format': 'عرض البطاقة بتنسيق مجلد',
    'Card Title': 'عنوان البطاقة',
    'Upload Card': 'رفع بطاقة',
    'Board layout': 'تخطيط اللوحة',
    'Maintain relative positioning': 'الحفاظ على الموضع النسبي',
    help_move: 'فعّل لسحب وإعادة ترتيب البطاقات على اللوحة.',
    help_select: 'فعّل لتحديد عدة بطاقات دفعة واحدة.',
    help_yesno: 'فعّل لإضافة أزرار نعم/لا على البطاقات.',
    help_undo_redo: 'تراجع أو أعد التغييرات على الإعدادات.',
    help_play_mode:
      'افتح اللوحة بملء الشاشة لاستخدامها فعليًا: تنقّل بين البطاقات والمجلدات، كوّن الجمل واستمع إليها.',
    help_export_pdf: 'تصدير اللوحة الحالية كملف PDF للطباعة أو المشاركة.',
    help_ia: 'استخدم الذكاء الاصطناعي لاقتراح البطاقات تلقائيًا.',
    'Card actions': 'إجراءات البطاقة',
    Interests: 'الاهتمامات',
    'Android ID': 'Android ID',
    'Advanced Filters': 'فلاتر متقدمة',
    'Apply Filters': 'تطبيق الفلاتر',
    'Clear All': 'مسح الكل',
    Order: 'ترتيب',
    Ascending: 'تصاعدي',
    Descending: 'تنازلي',
    From: 'من',
    To: 'إلى',
    All: 'الكل',
    Information: 'معلومات',
    Location: 'الموقع',
    Keys: 'المفاتيح',
    'Date of Birth': 'تاريخ الميلاد',
    'Activated Licenses': 'التراخيص المفعلة',
    'Inactivated Licenses': 'التراخيص المعطلة',
    Options: 'خيارات',
    Hide: 'إخفاء',
    Show: 'إظهار',
    'Enter sublevel': 'الدخول إلى المستوى الفرعي',
    'Create folder': 'إنشاء مجلد',
    'Edit Card': 'تعديل البطاقة',
    'Add state': 'إضافة حالة',
    'Cannot access cards with more than one state':
      'لا يمكن الوصول إلى البطاقات التي تحتوي على أكثر من حالة.',
    'Cards with sublevels cannot have multiple states':
      'البطاقات ذات المستويات الفرعية لا يمكن أن تحتوي على حالات متعددة.',
    Untitled: 'بدون عنوان',
    'No states yet. Add one below.': 'لا توجد حالات بعد. أضف واحدة أدناه.',
    'Generate image': 'إنشاء صورة',
    'Enter image prompt...': 'أدخل وصف الصورة...',
    'Image style': 'نمط الصورة',
    'Download image': 'تنزيل الصورة',
    Contains: 'يحتوي على',
    'Type to search symbols': 'اكتب للبحث عن الرموز',
    'Save failed': 'فشل الحفظ',
    'Choose file from computer': 'اختر ملفاً من الكمبيوتر',
    Upload: 'رفع',
    'Upload failed': 'فشل الرفع',
    'Select from image bank': 'اختر من بنك الصور',
    'Generate with AI': 'أنشئ بالذكاء الاصطناعي',
    Generated: 'تم الإنشاء',
    'Upload an image from your device': 'ارفع صورة من جهازك',
    'Choose a symbol from the image bank': 'اختر رمزاً من بنك الصور',
    Selected: 'محدد',
    'Unsaved image selected': 'صورة غير محفوظة محددة',
    'Upload image from computer': 'رفع صورة من الكمبيوتر',
    'Select an image before saving the card.': 'اختر صورة قبل حفظ البطاقة.',
    'Book Settings': 'إعدادات الكتاب',
    'Text size': 'حجم النص',
    'Highlight spoken text': 'إبراز النص المنطوق',
    Exit: 'خروج',
    'Start over': 'البدء من البداية',
    'To enable Book Mode, add cards to the board':
      'لتفعيل وضع الكتاب، أضف بطاقات إلى اللوحة',
    'Deactivate Book Mode to create sublevels':
      'أوقف وضع الكتاب لإنشاء مستويات فرعية',
    'Continue from page {{page}}': 'المتابعة من الصفحة {{page}}',
    'Open at page {{page}}': 'افتح عند الصفحة {{page}}',
    'To enable Book Mode, add child cards':
      'لتفعيل وضع الكتاب، أضف بطاقات فرعية',
    'This book has no pages': 'هذا الكتاب لا يحتوي على صفحات',
  },
}
